/* cache-bust: 1779984717178684200 */
/* cdn-bust 1777987422 */
/* DC MARKET — minimal vanilla JS for nav, drawer, qty, variant pills */

(() => {
  document.documentElement.classList.remove('no-js');

  // ── i18n locale detection (must be defined BEFORE any IIFE that uses it
  //    to avoid the const TDZ — temporal dead zone — ReferenceError) ──
  const DCM_LOCALE = (function () {
    var p = window.location.pathname || '';
    if (p === '/en' || p.indexOf('/en/') === 0) return 'en';
    if (p === '/de' || p.indexOf('/de/') === 0) return 'de';
    var hl = (document.documentElement.lang || '').toLowerCase().slice(0, 2);
    if (hl === 'en' || hl === 'de') return hl;
    return 'ro';
  })();

  // ── Locale-aware URL prefix ──────────────────────────────────────
  // On /en/* and /de/* pages, most internal links (especially section-
  // setting URLs like /pages/usi-industriale) lack the locale prefix.
  // Without this pass, every click on those links resets the visitor
  // back to Romanian. Walk every <a href="/..."> and prepend the locale.
  (function localizeInternalLinks() {
    if (DCM_LOCALE === 'ro') return;
    var prefix = '/' + DCM_LOCALE;
    function rewrite(root) {
      var scope = root || document;
      var links = scope.querySelectorAll ? scope.querySelectorAll('a[href]') : [];
      for (var i = 0; i < links.length; i++) {
        var a = links[i];
        if (a.dataset.dcmLocalized === '1') continue;
        var href = a.getAttribute('href');
        if (!href) continue;
        if (href[0] !== '/') continue;             // skip absolute, mailto:, tel:, #
        if (href.indexOf('//') === 0) continue;    // protocol-relative
        if (href.indexOf('/en/') === 0 || href === '/en') { a.dataset.dcmLocalized = '1'; continue; }
        if (href.indexOf('/de/') === 0 || href === '/de') { a.dataset.dcmLocalized = '1'; continue; }
        if (href.indexOf('/cdn/') === 0) continue;
        if (href.indexOf('/localization') === 0) continue;
        a.setAttribute('href', prefix + href);
        a.dataset.dcmLocalized = '1';
      }
    }
    rewrite();
    document.addEventListener('DOMContentLoaded', function () { rewrite(); });
    // Re-run after JS-injected nav + sections settle
    setTimeout(rewrite, 400);
    setTimeout(rewrite, 1500);
    setTimeout(rewrite, 3000);
    // Re-run on Shopify section editor reloads
    document.addEventListener('shopify:section:load', function (e) { rewrite(e && e.target); });
    // Catch dynamically-added links (mega menu, slideshows)
    if (typeof MutationObserver === 'function') {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            if (added[j].nodeType === 1) rewrite(added[j]);
          }
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }
  })();

  // ── Shopify Theme Editor: re-run all customizations whenever Shopify
  //    partial-renders a section or block (clicking around in the editor).
  //    Each setup function is registered via dcmRegister(); they run once
  //    at page load AND every time the editor fires a section event. ──
  var DCM_INIT = [];
  function dcmRegister(fn) {
    if (typeof fn !== 'function') return;
    DCM_INIT.push(fn);
    try { fn(document); } catch (e) { /* swallow on first run */ }
  }
  function dcmReinitAll(root) {
    DCM_INIT.forEach(function (fn) { try { fn(root || document); } catch (e) {} });
  }
  if (window.Shopify && Shopify.designMode) {
    [
      'shopify:section:load',
      'shopify:section:reorder',
      'shopify:section:select',
      'shopify:block:select',
      'shopify:block:deselect'
    ].forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(dcmReinitAll, 30); });
    });
  }

  // ── Anchor link smooth-scroll to known section IDs (e.g. #categorii) ──
  //    Adds id="categorii" to the categories section so the hero button
  //    can deep-link there. Smooth scroll respects prefers-reduced-motion.
  function setupSectionAnchors() {
    var cat = document.querySelector('.cat-split');
    if (!cat) return;
    // Shopify auto-generates an id on the .cat-split section (e.g.
    // "section-template--…__categories") so the original `if (!cat.id)`
    // check skipped adding our hash anchor. Instead, inject a separate
    // empty span with id="categorii" right at the top of the section —
    // doesn't touch the Shopify id, but `/#categorii` now resolves.
    if (!document.getElementById('categorii')) {
      var anchor = document.createElement('span');
      anchor.id = 'categorii';
      anchor.setAttribute('aria-hidden', 'true');
      anchor.style.cssText = 'display:block;position:relative;top:-80px;height:0;visibility:hidden;';
      cat.insertBefore(anchor, cat.firstChild);
    }
    var catSec = cat.closest('.shopify-section');
    if (catSec && !catSec.dataset.dcmAnchor) {
      catSec.dataset.dcmAnchor = 'categorii';
    }
  }
  dcmRegister(setupSectionAnchors);

  // Assign id="cat-{slug}" to each .cat-card so footer/external links can
  // deep-link straight to a specific homepage card. Slug derives from the
  // card's href (/pages/{slug}) or, when href is "#", from the title text.
  function dcmIdCatCards() {
    function slugify(s) {
      return (s || '')
        .toString()
        .toLowerCase()
        .replace(/[ăâà]/g, 'a').replace(/[èéê]/g, 'e').replace(/[ìí]/g, 'i')
        .replace(/[òó]/g, 'o').replace(/[ùú]/g, 'u').replace(/[șș]/g, 's')
        .replace(/[țț]/g, 't').replace(/[ñ]/g, 'n')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }
    document.querySelectorAll('.cat-card').forEach(function (card) {
      if (card.id) return;
      var slug = '';
      var href = card.getAttribute('href') || '';
      var m = href.match(/\/pages\/([^/?#]+)/);
      if (m) slug = m[1];
      if (!slug) {
        var t = card.querySelector('.cat-card__title');
        if (t) slug = slugify(t.textContent);
      }
      if (slug) card.id = 'cat-' + slug;
    });
  }
  dcmRegister(dcmIdCatCards);

  // Smooth-scroll anchor clicks (with sticky-header offset)
  (function smoothAnchors() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href === '#' || href.length < 2) return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      var headerH = (document.querySelector('.header')?.offsetHeight || 80) + 12;
      var top = target.getBoundingClientRect().top + window.scrollY - headerH;
      window.scrollTo({ top: top, behavior: 'smooth' });
      // Update URL hash without jump
      try { history.replaceState(null, '', href); } catch (_) {}
    });
  })();

  // ── Tap-feedback delay on touch devices ──
  // Show the hover-equivalent animation for 240ms before navigating, so the user
  // actually sees feedback when they tap a link (instead of nothing happening
  // until the next page paints). Honors reduced-motion + skips anchors/tel/mailto.
  (function tapFeedback() {
    if (!window.matchMedia) return;
    if (!matchMedia('(hover: none)').matches) return;             // pointer can hover → desktop, skip
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href]');
      if (!a || a.dataset.tapPlayed === '1') return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      if (/^(javascript:|mailto:|tel:|sms:)/i.test(href)) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download')) return;
      if (a.hasAttribute('data-no-delay')) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (e.button !== undefined && e.button !== 0) return;       // ignore middle/right click

      e.preventDefault();
      e.stopPropagation();
      a.classList.add('dcm-tap-active');

      setTimeout(function () {
        a.dataset.tapPlayed = '1';
        a.classList.remove('dcm-tap-active');
        // Use programmatic click so any default link behavior runs
        if (typeof a.click === 'function') a.click();
        else window.location.href = a.href;
      }, 240);
    }, true);
  })();

  // Trust-strip SVGs without preserveAspectRatio can clip on iOS Safari.
  // Force the canonical setting so the icon never gets cropped.
  (function fixTrustSvgs() {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.trust-cell__icon svg').forEach(function (svg) {
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        svg.style.overflow = 'visible';
      });
    });
  })();

  // Cat-card category tag chip removed per project decision —
  // the orange "INDUSTRIAL" / "CONTROL ACCES" / etc. pill that this
  // function injected on top of each .cat-card body has been retired.
  // The chip CSS string further down in this file is now dead code
  // but harmless (no elements to style). Function intentionally left
  // as a no-op for back-compat with any external caller of
  // dcmRegister(injectCatTags) — and to keep nothing else's
  // initialization order shifting.
  function injectCatTags() {}
  dcmRegister(injectCatTags);

  // Belt-and-braces: if any prior cached JS already injected the tags
  // before our removal landed, sweep them on DOM ready.
  (function sweepLegacyCatTags() {
    function sweep() {
      document.querySelectorAll('.dcm-cat-tag').forEach(function (el) { el.remove(); });
    }
    if (document.readyState !== 'loading') sweep();
    else document.addEventListener('DOMContentLoaded', sweep);
  })();

  // ── Homepage cat-split slider: inject a right-arrow nav button per
  //    section + wire it to smooth-scroll the inner .cat-split__grid
  //    by ~1 card width per click. Desktop only — CSS hides the
  //    button at <=989px so touch users swipe natively. We also keep
  //    an `is-at-end` class on the section so the arrow can fade out
  //    when there's nothing left to reveal.
  (function setupCatSplitArrow() {
    var ARROW_SVG =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<polyline points="8 4 16 12 8 20"></polyline>' +
      '</svg>';

    function step(grid) {
      var first = grid.querySelector('a, .cat-card');
      var stepPx = first ? first.getBoundingClientRect().width : 320;
      // Include gap so the next card snaps cleanly to the leading edge.
      var styles = window.getComputedStyle(grid);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return stepPx + gap;
    }

    function updateEnd(section, grid) {
      var maxScroll = grid.scrollWidth - grid.clientWidth - 2;
      if (grid.scrollLeft >= maxScroll) section.classList.add('is-at-end');
      else section.classList.remove('is-at-end');
    }

    function init() {
      document.querySelectorAll('.cat-split').forEach(function (section) {
        if (section.querySelector('.cat-split__nav-arrow')) return;
        var grid = section.querySelector('.cat-split__grid');
        if (!grid) return;

        // Wrap the grid in a positioning container so the arrow can
        // anchor to the slider's own height (not the whole section,
        // which would include the heading row above and push the
        // arrow off-center vertically).
        var slidWrap = grid.parentNode;
        if (!slidWrap.classList.contains('cat-split__slider-wrap')) {
          slidWrap = document.createElement('div');
          slidWrap.className = 'cat-split__slider-wrap';
          grid.parentNode.insertBefore(slidWrap, grid);
          slidWrap.appendChild(grid);
        }

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cat-split__nav-arrow';
        btn.setAttribute('aria-label', 'Vezi mai multe categorii');
        btn.innerHTML = ARROW_SVG;
        btn.addEventListener('click', function () {
          // Loop behavior: if we're already at the end, snap back
          // to the first card instead of fading out. Otherwise
          // advance by one card width + gap.
          var maxScroll = grid.scrollWidth - grid.clientWidth - 2;
          if (grid.scrollLeft >= maxScroll) {
            grid.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            grid.scrollBy({ left: step(grid), behavior: 'smooth' });
          }
        });
        slidWrap.appendChild(btn);

        // Track scroll position so the arrow fades at the end.
        var ticking = false;
        grid.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            updateEnd(section, grid);
          });
        }, { passive: true });
        window.addEventListener('resize', function () { updateEnd(section, grid); }, { passive: true });
        updateEnd(section, grid);
      });
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    // Also run after window load in case the section paints late.
    window.addEventListener('load', init);
  })();

  // Hero highlight: now rendered server-side by hero.liquid using each slide's
  // highlight_word setting. JS slideshow controller (below) swaps content on
  // slide change. Old last-word fallback removed.

  // ── Marquee strip moved to a proper Shopify section (sections/marquee-strip.liquid).
  //    JS fallback retained only if section file is missing for any reason. ──
  (function injectMarquee() {
    function build() {
      if (document.getElementById('dcm-brutal-marquee')) return;
      if (document.querySelector('[data-marquee-strip]')) return; // real section already on page
      return; // fallback disabled — section is the source of truth
      const trust = document.querySelector('.trust-strip')?.closest('.shopify-section');
      if (!trust) return;
      const items = ['MONTAJ PROFESIONIST', 'GARANȚIE 5 ANI', 'PLATĂ ÎN RATE', 'TRANSPORT NAȚIONAL', 'CONSULTANȚĂ GRATUITĂ', 'MĂSURĂTORI LA FAȚA LOCULUI'];
      const block = items.map(function (t) {
        return '<span class="dcm-bm__item">' + t + '</span><span class="dcm-bm__sep" aria-hidden="true">✦</span>';
      }).join('');
      const wrap = document.createElement('div');
      wrap.id = 'dcm-brutal-marquee';
      wrap.className = 'dcm-bm';
      wrap.setAttribute('aria-hidden', 'true');
      // Two copies of the track for seamless infinite scroll
      wrap.innerHTML = '<div class="dcm-bm__track">' + block + block + '</div>';
      trust.parentNode.insertBefore(wrap, trust);
    }
    document.addEventListener('DOMContentLoaded', build);
    if (document.readyState !== 'loading') build();
  })();

  // Load Roboto from Google Fonts — not installed on iOS by default,
  // so without this we fall through the stack to Arial/Helvetica.
  (function loadRoboto() {
    if (document.querySelector('link[href*="Roboto"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap';
    document.head.appendChild(l);
  })();

  // ── Mobile header sizing + safe-area-aware padding.
  //    Uses high specificity (.header .header__inner) to beat any base rule,
  //    safe-area-insets for iPhone notch / dynamic island side cutouts. ──
  // ── Quote-CTA: rewrite to credibility statement + 3 anchor stats.
  //    templates/index.json keeps reverting block contents — JS workaround.
  //    Locale-aware: copy is swapped per DCM_LOCALE (defined at top of file).──
  (function rewriteQuoteCta() {
    var QC_I18N = {
      ro: {
        heading: 'Peste 10.000 de uși montate în peste 25 de ani. <span class="dcm-stat-heading-accent">Următoarea poate fi a ta.</span>',
        lead: 'Trimite-ne un mesaj sau sună-ne. Răspundem în maxim 24h, cu o ofertă clară și fără surprize.',
        tel: 'sau sună-ne la <a href="tel:+40741117722">+40 74 111 77 22</a>',
        stats: [
          { num: '10.000+', label: 'uși montate' },
          { num: '25+',     label: 'ani de experiență' }
        ]
      },
      en: {
        heading: 'Over 10,000 doors installed in 25+ years. <span class="dcm-stat-heading-accent">Next one could be yours.</span>',
        lead: 'Send us a message or give us a call. We reply within 24h with a clear, no-surprises quote.',
        tel: 'or call us at <a href="tel:+40741117722">+40 74 111 77 22</a>',
        stats: [
          { num: '10,000+', label: 'doors installed' },
          { num: '25+',     label: 'years of experience' }
        ]
      },
      de: {
        heading: 'Über 10.000 Türen in über 25 Jahren installiert. <span class="dcm-stat-heading-accent">Ihre könnte die nächste sein.</span>',
        lead: 'Schreiben Sie uns oder rufen Sie an. Wir antworten innerhalb von 24h mit einem klaren Angebot — keine Überraschungen.',
        tel: 'oder rufen Sie uns an unter <a href="tel:+40741117722">+40 74 111 77 22</a>',
        stats: [
          { num: '10.000+', label: 'installierte Türen' },
          { num: '25+',     label: 'Jahre Erfahrung' }
        ]
      }
    };
    var QC = QC_I18N[DCM_LOCALE] || QC_I18N.ro;
    function paint() {
      var qc = document.querySelector('.quote-cta');
      if (!qc) return;
      var heading = qc.querySelector('.quote-cta__heading');
      var lead = qc.querySelector('.quote-cta__lead');
      if (heading && !heading.dataset.dcmRewrote) {
        heading.innerHTML = QC.heading;
        heading.dataset.dcmRewrote = '1';
      }
      if (lead && !lead.dataset.dcmRewrote) {
        lead.textContent = QC.lead;
        lead.dataset.dcmRewrote = '1';
      }
      // CTA button + tel link — removed per user request. Sweep
      // out the button on every paint, and don't inject the tel.
      // Anyone needing to contact still has the +40 phone in the
      // header announcement bar plus the cere-oferta CTA in the
      // main nav. Leaving this CTA-CTA stacking just made the
      // section read as noisy without adding a new path.
      qc.querySelectorAll('a.btn').forEach(function (b) {
        b.style.setProperty('display', 'none', 'important');
      });
      qc.querySelectorAll('.dcm-stat-tel').forEach(function (t) {
        t.style.setProperty('display', 'none', 'important');
      });
      // Replace the 4 bullets with 3 stat anchors
      var stats = QC.stats;
      var bullets = qc.querySelectorAll('.quote-cta__bullet');
      bullets.forEach(function (b, i) {
        if (b.dataset.dcmRewrote) return;
        if (i >= stats.length) { b.style.setProperty('display', 'none', 'important'); b.dataset.dcmRewrote = '1'; return; }
        var num = b.querySelector('.quote-cta__bullet-num');
        if (num) {
          num.textContent = stats[i].num;
          num.removeAttribute('style');
          num.classList.add('dcm-stat-num');
        }
        var labelSpan = b.querySelector('span:not(.quote-cta__bullet-num)');
        if (labelSpan) labelSpan.textContent = stats[i].label;
        b.classList.add('dcm-stat-row');
        b.dataset.dcmRewrote = '1';
      });

      // (Earlier experiment moved CTA button + tel link into the
      // bullets column to group action with stats — reverted because
      // it broke desktop spacing and clipped on mobile. Button + tel
      // stay in their natural left-column position.)

      // Remove any leftover Companii care ne-au ales tag from the quote-cta
      // (injection no longer wanted; sweep it out on every paint).
      qc.querySelectorAll('.dcm-partners-tag').forEach(function (el) { el.remove(); });
    }
    document.addEventListener('DOMContentLoaded', paint);
    if (document.readyState !== 'loading') paint();
    document.addEventListener('shopify:section:load', paint);
  })();

  (function tightenHeaderMobile() {
    // Mobile header: trust the theme's natural layout. Past attempts to override
    // padding/logo size made things worse — back to no-op. If the user wants a
    // specific tweak later, add it scoped narrowly here.
    var existing = document.getElementById('dcm-hdr-tight');
    if (existing) existing.remove();
  })();

  // ── A11y: ARIA labels for icon-only buttons in the header (per UX-guideline #40) ──
  (function ariaLabelHeaderIcons() {
    document.addEventListener('DOMContentLoaded', function () {
      var labels = [
        ['a[href*="account"]', 'Contul meu'],
        ['a[href*="cart"], button[aria-controls*="cart"]', 'Coș cumpărături'],
        ['button.header__menu-btn, [data-menu-open]', 'Deschide meniul'],
        ['button[aria-controls*="search"], a[href*="search"]', 'Caută']
      ];
      labels.forEach(function (pair) {
        document.querySelectorAll(pair[0]).forEach(function (el) {
          if (!el.getAttribute('aria-label') && !el.textContent.trim()) {
            el.setAttribute('aria-label', pair[1]);
          }
        });
      });
    });
  })();

  // ── Customize header: nav PORTOFOLIU/MAGAZIN, hide phone+search, inject CTA ──
  function customizeHeader() {
    const navList = document.querySelector('.header__nav-list');
    if (navList && navList.dataset.dcmMultiMega !== '1' && !navList.querySelector('[data-dcm-mega]')) {
      // DCM_HIDE_MAGAZIN — keep nav empty until injectDesktopMega populates it.
      navList.innerHTML = '';
    }
    const phone = document.querySelector('.header__phone');
    if (phone) phone.style.display = 'none';
    document.querySelectorAll('.header__icon-btn').forEach(btn => {
      const href = btn.getAttribute('href') || '';
      if (href.includes('search')) btn.style.display = 'none';
    });
    // Rewrite mobile menu drawer items to match desktop nav (locale-aware).
    // The first LI is a placeholder marker — injectMobileMega() finds it
    // via data-dcm-portfolio-marker and replaces it with the full category
    // mega-nav accordions. Then the orange 'Cere ofertă' CTA sits at the
    // bottom. (Contul meu + Contact were intentionally dropped — late-patch
    // scripts already strip them on RO; we just don't write them here.)
    const mobileList = document.querySelector('.mobile-menu__list');
    if (mobileList && !mobileList.querySelector('[data-dcm-mega]')) {
      var __mlbl = {
        ro: { portfolio: 'Portofoliu', quote: 'Cere ofertă' },
        en: { portfolio: 'Portfolio',  quote: 'Get a quote' },
        de: { portfolio: 'Portfolio',  quote: 'Angebot anfordern' }
      }[DCM_LOCALE] || { portfolio: 'Portofoliu', quote: 'Cere ofertă' };
      mobileList.innerHTML = [
        '<li data-dcm-portfolio-marker="1"><a href="/pages/portofoliu" data-menu-close>' + __mlbl.portfolio + '</a></li>',
        '<li><a href="/pages/cere-oferta" data-menu-close style="color: var(--color-orange);">' + __mlbl.quote + '</a></li>'
      ].join('');
    }
    // Inject hazard stripe between announcement bar and header (taller, with spacing below)
    const annSection = document.querySelector('.shopify-section-group-header-group .announcement, [id*="announcement"]')?.closest('.shopify-section') || document.querySelector('.shopify-section .announcement')?.closest('.shopify-section');
    if (annSection && !document.getElementById('dcm-hazard-mid')) {
      const hz = document.createElement('hr');
      hz.id = 'dcm-hazard-mid';
      hz.className = 'hazard';
      hz.setAttribute('aria-hidden', 'true');
      hz.style.cssText = 'height:14px;border:0;margin:0;display:block;';
      annSection.parentNode.insertBefore(hz, annSection.nextSibling);
    }
    // Hide any non-mid hazard inside the header group (the inline hr inside
    // announcement-bar.liquid was duplicating the JS-injected dcm-hazard-mid).
    document.querySelectorAll('.shopify-section-group-header-group hr.hazard').forEach(h => {
      if (h.id !== 'dcm-hazard-mid') h.style.display = 'none';
    });
    const actions = document.querySelector('.header__actions');
    if (actions && !actions.querySelector('.header__cta')) {
      const cta = document.createElement('a');
      cta.href = '/pages/cere-oferta';
      cta.className = 'btn btn--primary header__cta';
      cta.textContent = DCM_LOCALE === 'en' ? 'Get a quote' : DCM_LOCALE === 'de' ? 'Angebot anfordern' : 'Cere ofertă';
      const menuBtn = actions.querySelector('.header__menu-btn');
      if (menuBtn) actions.insertBefore(cta, menuBtn);
      else actions.appendChild(cta);
    }
    // Hide hero eyebrow (photo 1 doesn't have it)
    const eb = document.querySelector('.hero__eyebrow');
    if (eb) eb.style.display = 'none';
    // Logo height is controlled by Customize > Header > Înălțime logo settings
    // (logo_height_desktop / logo_height_mobile -> --logo-h-d / --logo-h-m vars)
    // Remove the line under the header
    const hdr = document.querySelector('.header');
    if (hdr) hdr.style.borderBottom = 'none';
    const ann = document.querySelector('.announcement');
    if (ann) ann.style.borderBottom = 'none';
  }
  dcmRegister(customizeHeader);

  /* Brute-force remove the announcement bar hours line. CSS display:none
     is being clobbered by other rules with equal/higher specificity that
     I can't reliably out-spec while the CDN cache is in flight, so kill
     the DOM node instead. */
  function removeAnnouncementHours() {
    document.querySelectorAll('.announcement__cell--hours').forEach(el => el.remove());
  }
  dcmRegister(removeAnnouncementHours);

  /* Kill JetBrains Mono everywhere — replace with Bebas Neue uppercase
     to match the announcement bar font across the whole site. */
  (function killJetBrainsMono() {
    if (document.getElementById('dcm-jbm-kill')) return;
    var s = document.createElement('style');
    s.id = 'dcm-jbm-kill';
    s.textContent =
      'html body .announcement__inner,html body .header__phone,html body .header__cart-count,' +
      'html body .hero__eyebrow,html body .hero__meta-inner,html body .hero-video__empty,' +
      'html body .cat-card__num,html body .cat-card__cta,html body .cat-card .empty-media,' +
      'html body .process__step-num,html body .testimonial__rating,html body .testimonial__author,' +
      'html body .quote-cta__bullet-num,html body .quote-form__step-num,html body .quote-form__submit-note,' +
      'html body .footer__col h4,html body .footer__contact .label,html body .footer__legal,html body .footer__badge-link,' +
      'html body .page-head__crumbs,html body .product__vendor,html body .product__price-row,' +
      'html body .product__variant-label,html body .product__qty button,html body .product__qty input,' +
      'html body .product__specs h3,html body .product__specs th,' +
      'html body .collection__filter-group h4,html body .collection__count,' +
      'html body .cart__summary-row,html body .cart__summary-total span,' +
      'html body .mono,html body .text-mono{' +
        'font-family:"Bebas Neue","Inter",sans-serif!important;' +
        'font-feature-settings:normal!important;' +
        'letter-spacing:0.1em!important;' +
        'text-transform:uppercase!important;' +
      '}';
    document.head.appendChild(s);
  })();

  /* Bigger announcement bar text on tablet + desktop */
  (function bigAnnouncementDesktop() {
    if (document.getElementById('dcm-announce-desktop')) return;
    var s = document.createElement('style');
    s.id = 'dcm-announce-desktop';
    s.textContent =
      '@media (min-width: 750px) {' +
        'html body .announcement.announcement--contact,' +
        'html body .announcement.announcement--contact .announcement__cell,' +
        'html body .announcement.announcement--contact .announcement__cell > span{font-size:1.6rem!important}' +
        'html body .announcement.announcement--contact .announcement__icon{width:16px!important;height:16px!important}' +
        'html body .announcement.announcement--contact .announcement__inner{min-height:46px!important;padding:0.95rem 1.3rem!important}' +
      '}';
    document.head.appendChild(s);
  })();

  /* Hero text shadow — always-on, soft dark halo for legibility on busy backgrounds */
  (function heroTextShadow() {
    if (document.getElementById('dcm-hero-text-shadow')) return;
    var s = document.createElement('style');
    s.id = 'dcm-hero-text-shadow';
    s.textContent =
      'html body .hero__heading,html body .hero__lead{' +
        'text-shadow:0 4px 24px rgba(14,14,16,0.6),0 2px 8px rgba(14,14,16,0.5),0 0 40px rgba(14,14,16,0.35) !important' +
      '}' +
      'html body .hero__heading-mark{text-shadow:none !important}';
    document.head.appendChild(s);
  })();

  /* Trust strip: dark inverted with hazard stripes */
  (function darkTrustStrip() {
    if (document.getElementById('dcm-trust-dark')) return;
    var s = document.createElement('style');
    s.id = 'dcm-trust-dark';
    s.textContent =
      'html body .shopify-section:has(.trust-strip){background:#0e0e10;position:relative;padding:5rem 0!important}' +
      'html body .shopify-section:has(.trust-strip)::before,html body .shopify-section:has(.trust-strip)::after{' +
        'content:"";position:absolute;left:0;right:0;height:6px;' +
        'background:repeating-linear-gradient(-45deg,#f7941d 0,#f7941d 14px,#0e0e10 14px,#0e0e10 28px)}' +
      'html body .shopify-section:has(.trust-strip)::before{top:0}' +
      'html body .shopify-section:has(.trust-strip)::after{bottom:0}' +
      'html body .trust-strip{background:transparent!important;border:0!important;gap:1.6rem!important}' +
      'html body .trust-strip .trust-row{background:transparent!important;border:0!important;box-shadow:none!important}' +
      'html body .trust-strip .wrap{background:transparent!important;border:0!important}' +
      'html body .trust-cell{background:transparent!important;border:0!important;padding:2rem 1.5rem!important}' +
      'html body .trust-cell__icon{width:64px!important;height:64px!important;display:inline-flex!important;' +
        'align-items:center;justify-content:center;margin-bottom:1.6rem!important;' +
        'border:2px solid #f7941d;background:rgba(247,148,29,0.08)}' +
      'html body .trust-cell__icon svg{width:28px!important;height:28px!important;color:#f7941d!important}' +
      'html body .trust-cell__icon path,html body .trust-cell__icon circle,html body .trust-cell__icon line,' +
      'html body .trust-cell__icon polyline{stroke:#f7941d!important}' +
      'html body .trust-cell__title{color:#fafaf7!important;font-size:1.6rem!important;letter-spacing:0.18em!important}' +
      'html body .trust-cell__text{color:rgba(244,243,239,0.62)!important}';
    document.head.appendChild(s);
  })();

  /* Logo gradient: shrink so it doesn't bleed into announcement bar / hamburger */
  (function tightenLogoGradient() {
    if (document.getElementById('dcm-logo-gradient-fix')) return;
    var s = document.createElement('style');
    s.id = 'dcm-logo-gradient-fix';
    s.textContent =
      'html body .header__logo::before{' +
        'width:160px!important;height:100px!important;' +
        'filter:blur(6px)!important;' +
        'background:radial-gradient(ellipse at center,rgba(14,14,16,.85) 0%,rgba(14,14,16,.45) 45%,rgba(14,14,16,0) 80%)!important;' +
      '}' +
      '@media (min-width:990px){' +
        'html body .header__logo::before{width:220px!important;height:130px!important}' +
      '}' +
      /* Hide gradient inside mobile drawer (cream bg — gradient looks ugly there) */
      'html body .mobile-menu .header__logo::before,' +
      'html body .mobile-menu__head .header__logo::before{' +
        'display:none!important;content:none!important;background:none!important;' +
      '}';
    document.head.appendChild(s);
  })();

  /* ── Category cards sizing — extracted from the disabled
     injectHomepageSections() IIFE so .cat-card titles stay at their
     compact desktop size (clamp 1.7-2rem) instead of falling back to
     the default 3.2rem.  Only the category-grid CSS is restored; the
     testimonials/FAQ injection stays off. */
  (function injectCatCardSizing() {
    if (document.getElementById('dcm-catcard-sizing-css')) return;
    var s = document.createElement('style');
    s.id = 'dcm-catcard-sizing-css';
    s.textContent = [
      '@media (min-width:990px){',
        'html body .cat-split__grid{grid-template-columns:repeat(4,1fr) !important;gap:1.6rem !important}',
        'html body .cat-card{aspect-ratio:auto !important;max-height:none !important}',
        'html body .cat-card__media{aspect-ratio:4/5 !important;height:auto !important;flex:0 0 auto !important}',
        'html body .cat-card__title{font-size:clamp(1.7rem,1.6vw,2rem) !important}',
        'html body .cat-card__cta{font-size:1.1rem !important;padding:.7rem 1.1rem !important}',
      '}',
      '@media (min-width:750px) and (max-width:989px){',
        'html body .cat-split__grid{grid-template-columns:repeat(2,1fr) !important;gap:1.6rem !important}',
        'html body .cat-card{aspect-ratio:auto !important}',
        'html body .cat-card__media{aspect-ratio:4/5 !important;height:auto !important;flex:0 0 auto !important}',
      '}'
    ].join('');
    document.head.appendChild(s);
  })();

  /* ── Homepage section injector — RE-ENABLED 2026-05-25 ──
     Injects testimonials + FAQ on the homepage. Anchored to quote_cta;
     quote_cta is now back in index.json so this works again. The earlier
     disable was a mistake — the user expected these sections visible. */
  (function injectHomepageSections() {
    // Homepage paths across locales: /, /en, /en/, /de, /de/
    var __p = window.location.pathname || '';
    var __isHome = __p === '/' || __p === '' || __p === '/en' || __p === '/en/' || __p === '/de' || __p === '/de/';
    if (!__isHome) return;
    if (document.getElementById('dcm-injected-sections')) return;

    var styles = document.createElement('style');
    styles.id = 'dcm-injected-sections-css';
    styles.textContent = [
      /* testimonials */
      '.dcm-x-testi{background:#fafaf7;padding:clamp(5rem,8vw,9rem) 0}',
      // Match the hero's container padding exactly: 2rem on mobile,
      // 4.8rem at ≥990px (defined in dcm-sections.css `.hero__inner`).
      // Without this, the testimonials heading + cards sat at 20px
      // from the viewport edge while the hero text sat at 48px — a
      // visible left-edge misalignment between the two sections.
      '.dcm-x-testi__inner{max-width:1440px;margin:0 auto;padding:0 2rem}',
      '@media (min-width:990px){.dcm-x-testi__inner{padding:0 4.8rem}}',
      '.dcm-x-testi__eyebrow{display:inline-flex;align-items:center;gap:.8rem;font-family:Inter,system-ui,sans-serif;font-size:1.1rem;font-weight:600;letter-spacing:.22em;text-transform:uppercase;color:#f7941d;margin-bottom:1.4rem}',
      '.dcm-x-testi__eyebrow::before{content:"";display:inline-block;width:24px;height:2px;background:#f7941d}',
      '.dcm-x-testi__h{font-family:"Bebas Neue","Inter",sans-serif;font-size:clamp(3.2rem,4.4vw,5.2rem);letter-spacing:.005em;line-height:1;color:#0e0e10;margin:0 0 4rem;max-width:24ch;text-transform:uppercase}',
      '.dcm-x-testi__grid{display:grid;grid-template-columns:1fr;gap:2rem}',
      '@media (min-width:750px){.dcm-x-testi__grid{grid-template-columns:repeat(3,1fr);gap:2.4rem}}',
      '.dcm-x-card{background:#fff;border:2px solid #0e0e10;padding:2.4rem 2rem;display:flex;flex-direction:column;gap:1.4rem;transition:transform .25s ease,box-shadow .25s ease}',
      '.dcm-x-card:hover{transform:translate(-3px,-3px);box-shadow:6px 6px 0 0 #f7941d}',
      '.dcm-x-card__stars{display:inline-flex;gap:2px}',
      '.dcm-x-card__quote{font-family:Inter,system-ui,sans-serif;font-size:1.5rem;line-height:1.6;color:#0e0e10;margin:0;flex:1 1 auto}',
      '.dcm-x-card__quote::before{content:"\\201C";color:#f7941d;font-size:2.6rem;line-height:0;vertical-align:-.45em;margin-right:.15em;font-weight:700}',
      '.dcm-x-card__author{border-top:1px solid rgba(14,14,16,.1);padding-top:1.4rem;display:flex;flex-direction:column;gap:.3rem}',
      '.dcm-x-card__name{font-family:"Bebas Neue","Inter",sans-serif;font-size:1.7rem;letter-spacing:.06em;color:#0e0e10;text-transform:uppercase}',
      '.dcm-x-card__role{font-family:Inter,system-ui,sans-serif;font-size:1.25rem;color:rgba(14,14,16,.55)}',
      /* categories tighten — 4-up grid on desktop, 2-up on tablet */
      '@media (min-width:990px){html body .cat-split__grid{grid-template-columns:repeat(4,1fr) !important;gap:1.6rem !important}html body .cat-card{aspect-ratio:auto !important;max-height:none !important}html body .cat-card__media{aspect-ratio:4/5 !important;height:auto !important;flex:0 0 auto !important}html body .cat-card__title{font-size:clamp(1.7rem,1.6vw,2rem) !important}html body .cat-card__cta{font-size:1.1rem !important;padding:.7rem 1.1rem !important}}',
      '@media (min-width:750px) and (max-width:989px){html body .cat-split__grid{grid-template-columns:repeat(2,1fr) !important;gap:1.6rem !important}html body .cat-card{aspect-ratio:auto !important}html body .cat-card__media{aspect-ratio:4/5 !important;height:auto !important;flex:0 0 auto !important}}',
      /* FAQ */
      '.dcm-x-faq{background:#fafaf7;padding:clamp(5rem,8vw,9rem) 0;border-top:1px solid rgba(14,14,16,.06)}',
      '.dcm-x-faq__inner{max-width:1100px;margin:0 auto;padding:0 2rem}',
      '.dcm-x-faq__head{text-align:center;margin:0 auto 4rem}',
      '.dcm-x-faq__h{font-family:"Bebas Neue","Inter",sans-serif;font-size:clamp(3rem,4vw,4.6rem);letter-spacing:.005em;line-height:1;color:#0e0e10;margin:0;text-transform:uppercase}',
      '.dcm-x-faq__list{display:flex;flex-direction:column}',
      '.dcm-x-q{border-top:1px solid rgba(14,14,16,.1)}',
      '.dcm-x-q:last-child{border-bottom:1px solid rgba(14,14,16,.1)}',
      '.dcm-x-q>summary{display:flex;align-items:center;justify-content:space-between;gap:1.6rem;padding:1.8rem 0;cursor:pointer;list-style:none;-webkit-tap-highlight-color:transparent}',
      '.dcm-x-q>summary::-webkit-details-marker{display:none}',
      '.dcm-x-q__t{font-family:"Bebas Neue","Inter",sans-serif;font-size:clamp(1.7rem,1.8vw,2.1rem);letter-spacing:.04em;text-transform:uppercase;color:#0e0e10}',
      '.dcm-x-q:hover .dcm-x-q__t{color:#f7941d}',
      '.dcm-x-q[open] .dcm-x-q__t{color:#0e0e10}',
      '.dcm-x-q__icon{position:relative;flex:0 0 auto;width:22px;height:22px;display:inline-flex;align-items:center;justify-content:center}',
      '.dcm-x-q__icon::before,.dcm-x-q__icon::after{content:"";position:absolute;width:16px;height:2px;background:#f7941d;transition:transform .25s ease,opacity .25s ease}',
      '.dcm-x-q__icon::after{transform:rotate(90deg)}',
      '.dcm-x-q[open] .dcm-x-q__icon::after{transform:rotate(0);opacity:0}',
      '.dcm-x-q__a{padding:0 0 2rem;font-family:Inter,system-ui,sans-serif;font-size:1.5rem;line-height:1.65;color:rgba(14,14,16,.75);max-width:70ch}',
      '.dcm-x-q__a p{margin:0 0 .8em}',
      '.dcm-x-q__a p:last-child{margin-bottom:0}',
      /* FAQ closing CTA — Stripe-docs-style contact rail */
      '.dcm-x-faq__footer{margin-top:4rem;padding:3rem 2.4rem;border:2px solid #0e0e10;background:#fff;display:flex;flex-direction:column;align-items:center;gap:1.6rem;text-align:center}',
      '@media (min-width:750px){.dcm-x-faq__footer{flex-direction:row;justify-content:space-between;text-align:left;padding:2.4rem 3rem}}',
      '.dcm-x-faq__footer-q{font-family:"Bebas Neue","Inter",sans-serif;font-size:clamp(1.7rem,2vw,2.2rem);letter-spacing:.04em;text-transform:uppercase;color:#0e0e10;margin:0}',
      '.dcm-x-faq__footer-actions{display:flex;flex-direction:column;gap:1.2rem;align-items:center}',
      '@media (min-width:750px){.dcm-x-faq__footer-actions{flex-direction:row;gap:2rem}}',
      '.dcm-x-faq__footer-tel{display:inline-flex;align-items:center;gap:.7rem;font-family:"Bebas Neue","Inter",sans-serif;font-size:1.5rem;letter-spacing:.06em;color:#0e0e10;text-decoration:none;padding:1rem 1.4rem;border:2px solid #0e0e10;background:#f7941d;transition:transform .2s ease,box-shadow .2s ease}',
      '.dcm-x-faq__footer-tel:hover{transform:translate(-2px,-2px);box-shadow:4px 4px 0 0 #0e0e10}',
      '.dcm-x-faq__footer-quote{font-family:"Bebas Neue","Inter",sans-serif;font-size:1.4rem;letter-spacing:.06em;color:#0e0e10;text-decoration:none;border-bottom:2px solid #f7941d;padding-bottom:2px;transition:color .2s ease,border-color .2s ease}',
      '.dcm-x-faq__footer-quote:hover{color:#f7941d}',
      /* final CTA */
      '.dcm-x-cta{position:relative;background:#0e0e10;color:#fafaf7;padding:clamp(6rem,10vw,10rem) 0;overflow:hidden}',
      '.dcm-x-cta::before{content:"";position:absolute;top:0;left:0;right:0;height:6px;background:repeating-linear-gradient(-45deg,#f7941d 0,#f7941d 14px,#0e0e10 14px,#0e0e10 28px)}',
      '.dcm-x-cta__inner{max-width:900px;margin:0 auto;padding:0 2rem;text-align:center;position:relative;z-index:1}',
      '.dcm-x-cta__h{font-family:"Bebas Neue","Inter",sans-serif;font-size:clamp(3.6rem,6vw,6.4rem);letter-spacing:.005em;line-height:.98;margin:0 0 1.6rem;text-transform:uppercase;color:#fafaf7}',
      '.dcm-x-cta__sub{font-family:Inter,system-ui,sans-serif;font-size:clamp(1.5rem,1.4vw,1.75rem);line-height:1.55;color:rgba(244,243,239,.72);margin:0 auto 3.2rem;max-width:56ch}',
      '.dcm-x-cta__btns{display:inline-flex;flex-wrap:wrap;gap:1.2rem;justify-content:center}',
      '.dcm-x-cta a{display:inline-flex;align-items:center;gap:.8rem;padding:1.4rem 2.2rem;font-family:"Bebas Neue","Inter",sans-serif;font-size:1.5rem;letter-spacing:.08em;text-transform:uppercase;text-decoration:none;cursor:pointer;transition:transform .2s ease,background .2s ease,color .2s ease,box-shadow .2s ease}',
      '.dcm-x-cta__btn-primary{background:#f7941d;color:#0e0e10;border:2px solid #f7941d;box-shadow:6px 6px 0 0 #fafaf7}',
      '.dcm-x-cta__btn-primary:hover{transform:translate(-3px,-3px);box-shadow:10px 10px 0 0 #fafaf7}',
      '.dcm-x-cta__btn-ghost{background:transparent;color:#fafaf7;border:2px solid rgba(250,250,247,.4)}',
      '.dcm-x-cta__btn-ghost:hover{border-color:#f7941d;color:#f7941d}',
      '.dcm-x-cta__tel{margin:2rem 0 0;font-family:Inter,system-ui,sans-serif;font-size:1.4rem;color:rgba(244,243,239,.62);letter-spacing:.02em}',
      '.dcm-x-cta__tel a{color:#fafaf7;text-decoration:underline;text-underline-offset:4px;text-decoration-color:rgba(247,148,29,.6);text-decoration-thickness:1.5px;font-weight:500;transition:color .2s ease,text-decoration-color .2s ease}',
      '.dcm-x-cta__tel a:hover{color:#f7941d;text-decoration-color:#f7941d}',
      /* Drop eyebrows on the homepage — heading carries the section */
      'body.template-index .eyebrow,body.template-index .dcm-x-testi__eyebrow,body.template-index .dcm-x-faq__eyebrow,body.template-index .dcm-x-cta__eyebrow,body.template-index .cat-split__head .eyebrow{display:none !important}',
      'body.template-index .dcm-x-faq__head{margin-bottom:4rem}',
      /* Drop redundant lead paragraph under merged stat heading */
      'body.template-index .quote-cta__lead{display:none !important}',
      /* Quote-CTA merged with final CTA: accent line + inline phone link */
      '.dcm-stat-heading-accent{display:inline-block;background:#f7941d;color:#0e0e10;padding:.15em .5em .2em;margin-top:1.2rem;box-shadow:8px 8px 0 0 #0e0e10;line-height:1;font-size:.72em;letter-spacing:.02em;white-space:nowrap}',
      '@media (max-width:749px){.dcm-stat-heading-accent{font-size:.85em;white-space:normal}}',
      '.dcm-stat-tel{margin:1.6rem 0 0;font-family:Inter,system-ui,sans-serif;font-size:1.4rem;color:rgba(244,243,239,.62);letter-spacing:.02em}',
      '.scheme-paper .dcm-stat-tel,.dcm-stat-tel.scheme-paper{color:rgba(14,14,16,.6)}',
      '.dcm-stat-tel a{color:inherit;text-decoration:underline;text-underline-offset:4px;text-decoration-color:rgba(247,148,29,.7);text-decoration-thickness:1.5px;font-weight:600;transition:color .2s ease,text-decoration-color .2s ease}',
      '.scheme-ink .dcm-stat-tel a{color:#fafaf7}',
      '.dcm-stat-tel a:hover{color:#f7941d;text-decoration-color:#f7941d}',
      '@media (max-width:749px){.dcm-x-cta__btns{flex-direction:column;align-items:stretch;width:100%}.dcm-x-cta a{justify-content:center;font-size:1.35rem;padding:1.2rem 1.6rem}}'
    ].join('');
    document.head.appendChild(styles);

    function star(filled) {
      return '<svg viewBox="0 0 24 24" width="16" height="16" fill="' + (filled ? '#f7941d' : 'rgba(14,14,16,.12)') + '"><path d="M12 2l2.92 6.69L22 9.74l-5.46 4.73L18.18 22 12 18.27 5.82 22l1.64-7.53L2 9.74l7.08-1.05L12 2z"/></svg>';
    }
    function stars(n) { return [1,2,3,4,5].map(function(i){return star(i<=n);}).join(''); }

    var SECTIONS_I18N = {
      ro: {
        testi_h: 'Reputația se construiește ușă cu ușă, client cu client.',
        faq_h: 'Întrebări frecvente',
        faq_no_answer: 'Nu găsești răspunsul?',
        faq_quote_cta: 'Cere ofertă personalizată →',
        TESTIMONIALS: [
          { q: 'Cele 6 uși secționale industriale au fost montate în 2 zile. Echipă profesionistă, materiale premium. La 18 luni de la montaj, funcționează impecabil.', n: 'Andrei Marinescu', r: 'Director facilități — Hala Otopeni', s: 5 },
          { q: 'Avem 12 uși industriale rapide montate de DC Market în depozitul nostru. Service rapid, garanție respectată, oameni de cuvânt.', n: 'Mihaela Stancu', r: 'Director logistică — Retail RO', s: 5 },
          { q: 'De la consultanță până la montaj, totul a decurs natural. Prețul corect, oferta clară, fără surprize. Recomand.', n: 'Cristian Dumitrache', r: 'Antreprenor general — Cluj', s: 5 }
        ],
        FAQS: [
          { q: 'Cum se face măsurarea ușii?', a: '<p>Venim la fața locului, gratuit, în orice județ. Echipa noastră măsoară deschiderea, evaluează spațiul tehnic și recomandă tipul de ușă potrivit. Programarea durează ~30 minute.</p>' },
          { q: 'Cât durează montajul?', a: '<p>Pentru o ușă industrială standard: <strong>3-5 ore</strong>, într-o singură zi. Pentru proiecte mai complexe sau mai multe uși: 1-3 zile, programat în avans.</p>' },
          { q: 'Livrați în toată țara?', a: '<p>Da. Livrăm și montăm în toate cele 41 de județe ale României. Termenele sunt comunicate clar la confirmarea comenzii (10-21 zile lucrătoare în funcție de model și zonă).</p>' },
          { q: 'Ce branduri lucrați?', a: '<p>Lucrăm exclusiv cu producători europeni cu reputație: <strong>Hörmann, BFT, Nice</strong> și alți parteneri certificați. Toate produsele respectă normele europene și sunt acoperite de garanția producătorului.</p>' },
          { q: 'Pot fi montate uși la o construcție existentă?', a: '<p>Da. Lucrăm atât pe construcții noi cât și pe clădiri existente. Echipa noastră evaluează spațiul și recomandă soluția potrivită — chiar și în cazul deschiderilor neregulate sau spațiilor tehnice limitate.</p>' },
          { q: 'Oferiți service post-vânzare?', a: '<p>Da. Avem echipă proprie de service în toată România. Răspundem în 48h pentru intervenții și oferim contracte de mentenanță preventivă pentru clienții industriali.</p>' }
        ]
      },
      en: {
        testi_h: 'Reputation is built door by door, client by client.',
        faq_h: 'Frequently asked questions',
        faq_no_answer: "Can't find your answer?",
        faq_quote_cta: 'Get a custom quote →',
        TESTIMONIALS: [
          { q: 'Six industrial sectional doors installed in 2 days. Professional team, premium materials. 18 months in, they still work flawlessly.', n: 'Andrei Marinescu', r: 'Facilities Director — Otopeni warehouse', s: 5 },
          { q: 'We have 12 high-speed industrial doors installed by DC Market in our warehouse. Fast service, warranty honored, people of their word.', n: 'Mihaela Stancu', r: 'Logistics Director — Retail RO', s: 5 },
          { q: 'From consulting through installation, everything went smoothly. Fair price, clear offer, no surprises. I recommend them.', n: 'Cristian Dumitrache', r: 'General contractor — Cluj', s: 5 }
        ],
        FAQS: [
          { q: 'How are door measurements taken?', a: '<p>We come to your site, free of charge, anywhere in Romania. Our team measures the opening, assesses the technical space, and recommends the right door type. The visit takes ~30 minutes.</p>' },
          { q: 'How long does installation take?', a: '<p>For a standard residential door: <strong>3-5 hours</strong>, in a single day. For industrial doors or multi-door projects: 1-3 days, scheduled in advance.</p>' },
          { q: 'Do you deliver across the country?', a: '<p>Yes. We deliver and install in all 41 Romanian counties. Lead times are communicated clearly upon order confirmation (10-21 business days depending on model and region).</p>' },
          { q: 'Which brands do you work with?', a: '<p>We work exclusively with reputable European manufacturers: <strong>Hörmann, BFT, Nice</strong> and other certified partners. All products meet European standards and are covered by the manufacturer warranty.</p>' },
          { q: 'Can doors be installed on existing buildings?', a: '<p>Yes. We work on both new builds and existing buildings. Our team assesses the space and recommends the right solution — even for irregular openings or limited technical spaces.</p>' },
          { q: 'Do you offer after-sales service?', a: '<p>Yes. We have our own service team across Romania. We respond within 48h for interventions and offer preventive maintenance contracts for industrial customers.</p>' }
        ]
      },
      de: {
        testi_h: 'Ein Ruf entsteht Tür für Tür, Kunde für Kunde.',
        faq_h: 'Häufig gestellte Fragen',
        faq_no_answer: 'Antwort nicht gefunden?',
        faq_quote_cta: 'Individuelles Angebot anfordern →',
        TESTIMONIALS: [
          { q: 'Sechs Industrie-Sektionaltore in 2 Tagen montiert. Professionelles Team, Premium-Materialien. Nach 18 Monaten funktioniert alles einwandfrei.', n: 'Andrei Marinescu', r: 'Leitung Facility — Lagerhalle Otopeni', s: 5 },
          { q: 'Wir haben 12 Schnelllauf-Industrietore von DC Market in unserem Lager. Schneller Service, eingehaltene Garantie, verlässliche Leute.', n: 'Mihaela Stancu', r: 'Leitung Logistik — Retail RO', s: 5 },
          { q: 'Von der Beratung bis zur Montage lief alles reibungslos. Fairer Preis, klares Angebot, keine Überraschungen. Sehr empfehlenswert.', n: 'Cristian Dumitrache', r: 'Generalunternehmer — Cluj', s: 5 }
        ],
        FAQS: [
          { q: 'Wie wird das Tor ausgemessen?', a: '<p>Wir kommen kostenlos zu Ihnen vor Ort, in jedem rumänischen Bezirk. Unser Team misst die Öffnung, prüft den technischen Raum und empfiehlt den passenden Tortyp. Der Termin dauert ca. 30 Minuten.</p>' },
          { q: 'Wie lange dauert die Montage?', a: '<p>Für ein Standard-Wohnhaustor: <strong>3-5 Stunden</strong> an einem Tag. Für Industrietore oder Mehr-Tor-Projekte: 1-3 Tage, vorab terminiert.</p>' },
          { q: 'Liefern Sie landesweit?', a: '<p>Ja. Wir liefern und montieren in allen 41 Bezirken Rumäniens. Lieferzeiten werden bei Auftragsbestätigung klar mitgeteilt (10-21 Werktage je nach Modell und Region).</p>' },
          { q: 'Mit welchen Marken arbeiten Sie?', a: '<p>Wir arbeiten ausschließlich mit renommierten europäischen Herstellern: <strong>Hörmann, BFT, Nice</strong> sowie weiteren zertifizierten Partnern. Alle Produkte entsprechen europäischen Normen und sind durch die Herstellergarantie abgedeckt.</p>' },
          { q: 'Können Tore in Bestandsgebäuden montiert werden?', a: '<p>Ja. Wir arbeiten sowohl an Neubauten als auch an Bestandsgebäuden. Unser Team bewertet den Raum und empfiehlt die passende Lösung — auch bei unregelmäßigen Öffnungen oder begrenzten technischen Räumen.</p>' },
          { q: 'Bieten Sie After-Sales-Service an?', a: '<p>Ja. Wir haben ein eigenes Service-Team in ganz Rumänien. Wir reagieren innerhalb von 48h auf Einsätze und bieten präventive Wartungsverträge für Industriekunden an.</p>' }
        ]
      }
    };
    var __S = SECTIONS_I18N[DCM_LOCALE] || SECTIONS_I18N.ro;
    var TESTIMONIALS = __S.TESTIMONIALS;
    var FAQS = __S.FAQS;

    var marker = document.createElement('div');
    marker.id = 'dcm-injected-sections';
    marker.style.cssText = 'display:contents';

    // 1. Client logo carousel — moved to a real Shopify section
    //    (sections/dcm-client-logos.liquid, section key "clients" on
    //    templates/index.json). The JS no longer injects this block;
    //    the section is rendered by Shopify and detected by the
    //    `find('clients')` lookup below. TESTIMONIALS array kept above
    //    for clean rollback.

    // 2. FAQ
    var faq = document.createElement('section');
    faq.className = 'dcm-x-faq';
    faq.innerHTML =
      '<div class="dcm-x-faq__inner">' +
        '<div class="dcm-x-faq__head">' +
          '<h2 class="dcm-x-faq__h">' + __S.faq_h + '</h2>' +
        '</div>' +
        '<div class="dcm-x-faq__list">' +
          FAQS.map(function (f) {
            return '<details class="dcm-x-q">' +
              '<summary><span class="dcm-x-q__t">' + f.q + '</span><span class="dcm-x-q__icon"></span></summary>' +
              '<div class="dcm-x-q__a">' + f.a + '</div>' +
            '</details>';
          }).join('') +
        '</div>' +
        /* Closing CTA — pattern used by Stripe / Linear / Vercel docs.
           Users who scan FAQ often want direct contact; surfacing
           phone + chat here removes a click to the footer. */
        '<div class="dcm-x-faq__footer">' +
          '<p class="dcm-x-faq__footer-q">' + __S.faq_no_answer + '</p>' +
          '<div class="dcm-x-faq__footer-actions">' +
            '<a class="dcm-x-faq__footer-tel" href="tel:+40741117722">' +
              '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.86.31 1.71.55 2.54a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.54-1.13a2 2 0 0 1 2.11-.45c.83.24 1.68.42 2.54.55A2 2 0 0 1 22 16.92z"/></svg>' +
              '<span>+40 74 111 77 22</span>' +
            '</a>' +
            '<a class="dcm-x-faq__footer-tel" href="tel:+40771054089">' +
              '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.86.31 1.71.55 2.54a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.54-1.13a2 2 0 0 1 2.11-.45c.83.24 1.68.42 2.54.55A2 2 0 0 1 22 16.92z"/></svg>' +
              '<span>+40 771 054 089</span>' +
            '</a>' +
            '<a class="dcm-x-faq__footer-quote" href="/pages/cere-oferta">' + __S.faq_quote_cta + '</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    marker.appendChild(faq);

    // 3. Final CTA — DISABLED: merged into quote_cta (stat block) above.
    var cta = null;

    // Reorder + insert: place testimonials AFTER quote_cta, FAQ + final CTA AFTER brands.
    // Also REORDER existing sections into the desired flow.
    var main = document.querySelector('main');
    if (!main) return;

    // Move brands to AFTER testimonials in display order:
    // current: hero, marquee, brands, trust, categories, quote_cta, clients
    // target:  hero, marquee, trust, categories, quote_cta, [testimonials], brands, [faq, final-cta]
    function find(suffix) {
      return Array.from(main.children).find(function (el) { return el.id && el.id.endsWith('__' + suffix); });
    }
    var trust = find('trust');
    var categories = find('categories');
    var quote = find('quote_cta');
    var brands = find('brands');
    var clients = find('clients');

    // Soluții (categories) must sit RIGHT AFTER the hero so the parallax-hero
    // building tucks UNDER it on scroll; the trust cards and everything else
    // follow below. NOTE: this block previously did the OPPOSITE — it
    // force-moved `trust` ABOVE `categories` on every load, silently overriding
    // the theme-editor / index.json order (the cards always rendered above
    // Soluții no matter what the file said). That override is removed; we now
    // only guarantee categories lands directly after the hero.
    var heroSec = find('hero');
    if (heroSec && categories) {
      main.insertBefore(categories, heroSec.nextSibling);  // categories right after hero
    }
    // Anchor for FAQ ordering: prefer the new clients section, fall back
    // to brands. Order on the page becomes:
    //   quote_cta → clients (logo carousel) → brands → FAQ → cta
    var anchor = clients || brands;
    if (brands && clients) {
      // Keep brands after the clients carousel
      main.insertBefore(brands, clients.nextSibling);
      anchor = brands;
    }
    if (anchor) {
      main.insertBefore(faq, anchor.nextSibling);
      if (cta) main.insertBefore(cta, faq.nextSibling);
    }

    // Mark done so we don't re-insert
    document.body.appendChild(marker);
  })();

  // ── i18n map for JS-injected mega-nav (DCM_LOCALE is defined at top of IIFE) ──
  // The mega-nav labels live in DCM_CATEGORIES below as hard-coded RO strings.
  // Shopify's translatableResource mechanism can't reach them because they
  // never enter the DOM through Liquid. We patch the array in place.
  const DCM_NAV_I18N = {
    en: {
      // top-level (name + short)
      'usi-industriale': { name: 'Industrial Doors', short: 'Industrial' },
      'usi-rezistente-la-foc': { name: 'Fire-Resistant Doors', short: 'Fire-resistant' },
      'usi-pietonale': { name: 'Pedestrian Doors', short: 'Pedestrian' },
      'usi-automate': { name: 'Automatic Doors', short: 'Automatic' },
      'usi-spitale': { name: 'Hospital Doors', short: 'Hospital' },
      'automatizari-porti': { name: 'Gate Operators', short: 'Operators' },
      'porti-aluminiu': { name: 'Aluminium Gates', short: 'Aluminium' },
      'bariere-bolarzi': { name: 'Barriers & Bollards', short: 'Barriers' },
      // subs
      'usi-sectionale-industriale': { name: 'Sectional doors' },
      'usi-rulou-industriale': { name: 'Rolling doors' },
      'usi-rapide': { name: 'High-speed doors' },
      'usi-batante-industriale': { name: 'Swing doors' },
      'usi-culisante-industriale': { name: 'Sliding doors' },
      'usi-armonice': { name: 'Folding doors' },
      'usi-pietonale-rezistente-la-foc': { name: 'Pedestrian fire doors' },
      'usi-culisante-rezistente-la-foc': { name: 'Sliding fire doors' },
      'usi-telescopice-rezistente-la-foc': { name: 'Telescopic fire doors' },
      'cortine-rezistente-la-foc': { name: 'Fire curtains' },
      'usi-multifunctionale-int-ext': { name: 'Multifunctional doors' },
      'usi-metalice-interior': { name: 'Interior steel doors' },
      'usi-de-lemn': { name: 'Wooden doors' },
      'usi-intrare-casa': { name: 'House entry doors' },
      'usi-intrare-apartament': { name: 'Apartment entry doors' },
      'automatizari-porti-batante': { name: 'Swing gate operators' },
      'automatizari-brat-articulat': { name: 'Articulated arm operators' },
      'automatizari-porti-culisante': { name: 'Sliding gate operators' },
      'porti-aluminiu-batante': { name: 'Swing gates' },
      'porti-aluminiu-culisante': { name: 'Cantilever sliding gates' },
      'bariere-3m': { name: 'Barriers 3m' },
      'bariere-5m': { name: 'Barriers 5m' },
      'bariere-2m': { name: 'Barriers 2m' },
      'bolarzi': { name: 'Bollards' },
      'tehnica-de-incarcare': { name: 'Loading Technology', short: 'Loading' },
      'rampe-egalizare': { name: 'Dock levellers' },
      'platforme-incarcare': { name: 'Loading platforms' },
      'burdufuri-de-incarcare': { name: 'Dock shelters' },
      'accesorii-andocare': { name: 'Docking accessories' }
    },
    de: {
      'usi-industriale': { name: 'Industrietore', short: 'Industrie' },
      'usi-rezistente-la-foc': { name: 'Feuerschutztüren', short: 'Feuerschutz' },
      'usi-pietonale': { name: 'Personentüren', short: 'Personen' },
      'usi-automate': { name: 'Automatiktüren', short: 'Automatik' },
      'usi-spitale': { name: 'Krankenhaustüren', short: 'Krankenhaus' },
      'automatizari-porti': { name: 'Torantriebe', short: 'Antriebe' },
      'porti-aluminiu': { name: 'Aluminium-Tore', short: 'Aluminium' },
      'bariere-bolarzi': { name: 'Schranken & Poller', short: 'Schranken' },
      'usi-sectionale-industriale': { name: 'Sektionaltore' },
      'usi-rulou-industriale': { name: 'Rolltore' },
      'usi-rapide': { name: 'Schnelllauftore' },
      'usi-batante-industriale': { name: 'Drehflügeltore' },
      'usi-culisante-industriale': { name: 'Schiebetore' },
      'usi-armonice': { name: 'Falttore' },
      'usi-pietonale-rezistente-la-foc': { name: 'Feuerschutz-Personentüren' },
      'usi-culisante-rezistente-la-foc': { name: 'Feuerschutz-Schiebetüren' },
      'usi-telescopice-rezistente-la-foc': { name: 'Feuerschutz-Teleskoptüren' },
      'cortine-rezistente-la-foc': { name: 'Feuerschutzvorhänge' },
      'usi-multifunctionale-int-ext': { name: 'Multifunktionstüren' },
      'usi-metalice-interior': { name: 'Stahltüren (Innen)' },
      'usi-de-lemn': { name: 'Holztüren' },
      'usi-intrare-casa': { name: 'Hauseingangstüren' },
      'usi-intrare-apartament': { name: 'Wohnungseingangstüren' },
      'automatizari-porti-batante': { name: 'Drehtorantriebe' },
      'automatizari-brat-articulat': { name: 'Gelenkarmantriebe' },
      'automatizari-porti-culisante': { name: 'Schiebetorantriebe' },
      'porti-aluminiu-batante': { name: 'Drehflügeltore' },
      'porti-aluminiu-culisante': { name: 'Freitragende Schiebetore' },
      'bariere-3m': { name: 'Schranken 3m' },
      'bariere-5m': { name: 'Schranken 5m' },
      'bariere-2m': { name: 'Schranken 2m' },
      'bolarzi': { name: 'Poller' },
      'tehnica-de-incarcare': { name: 'Verladetechnik', short: 'Verlade' },
      'rampe-egalizare': { name: 'Überladebrücken' },
      'platforme-incarcare': { name: 'Ladeplattformen' },
      'burdufuri-de-incarcare': { name: 'Torabdichtungen' },
      'accesorii-andocare': { name: 'Andockzubehör' }
    }
  };
  function dcmI18nCats(cats) {
    if (DCM_LOCALE === 'ro') return cats;
    var map = DCM_NAV_I18N[DCM_LOCALE] || {};
    cats.forEach(function (c) {
      var t = map[c.slug];
      if (t) {
        if (t.name) c.name = t.name;
        if (t.short) c.short = t.short;
      }
      (c.subs || []).forEach(function (s) {
        var st = map[s.slug];
        if (st && st.name) s.name = st.name;
      });
    });
    return cats;
  }

  // ── Categories megamenu under Portofoliu ──────────────────────────
  // 8 categories from the user's spec; each opens a subcategory panel.
  // NOTE: shopify often silently reverts edits to this file; if you change
  // a `short` label and it doesn't stick, patch via the runtime override IIFE
  // at the bottom (search for "DCM_NAV_RELABEL").
  const DCM_CATEGORIES = dcmI18nCats([
    { slug: 'usi-industriale', name: 'Uși Industriale', short: 'Industriale', subs: [
      { slug: 'usi-sectionale-industriale', name: 'Uși secționale' },
      { slug: 'usi-rulou-industriale', name: 'Uși rulou' },
      { slug: 'usi-rapide', name: 'Uși rapide' },
      { slug: 'usi-batante-industriale', name: 'Uși batante' }
    ]},
    { slug: 'usi-rezistente-la-foc', name: 'Uși rezistente la foc', short: 'Rezistente foc', subs: [
      { slug: 'usi-pietonale-rezistente-la-foc', name: 'Uși pietonale' },
      { slug: 'usi-culisante-rezistente-la-foc', name: 'Uși culisante' },
      { slug: 'usi-telescopice-rezistente-la-foc', name: 'Uși telescopice' },
      { slug: 'cortine-rezistente-la-foc', name: 'Cortine rezistente la foc' }
    ]},
    { slug: 'automatizari-porti', name: 'Automatizări', short: 'Automatizări', subs: [
      { slug: 'automatizari-porti-batante', name: 'Automatizări porți batante', url: '/pages/automatizari-porti-batante#sisteme-de-actionare-pentru-porti-batante' },
      { slug: 'automatizari-porti-culisante', name: 'Automatizări porți culisante', url: '/pages/automatizari-porti-batante#sisteme-de-actionare-pentru-porti-culisante' },
      { slug: 'automatizari-brat-articulat', name: 'Automatizări cu braț articulat', url: '/pages/automatizari-porti-batante#versamatic' }
    ]},
    { slug: 'porti-aluminiu', name: 'Porți aluminiu', short: 'Aluminiu', subs: [
      { slug: 'porti-aluminiu-batante', name: 'Porți batante', url: '/pages/porti-industriale' },
      { slug: 'porti-aluminiu-culisante', name: 'Porți culisante autoportante', url: '/pages/porti-industriale' }
    ]},
    { slug: 'bariere-bolarzi', name: 'Bariere & bolarzi', short: 'Bariere', subs: [
      { slug: 'bariere', name: 'Bariere' },
      { slug: 'bolarzi', name: 'Bolarzi' }
    ]},
    { slug: 'tehnica-de-incarcare', name: 'Tehnica de încărcare', short: 'Încărcare', subs: [
      { slug: 'rampe-egalizare', name: 'Rampe egalizare' },
      { slug: 'platforme-incarcare', name: 'Platforme încărcare' },
      { slug: 'burdufuri-de-incarcare', name: 'Burdufuri de etanșare' },
      { slug: 'accesorii-andocare', name: 'Accesorii andocare' }
    ]},
    { slug: 'usi-de-garaj', name: 'Uși de garaj', short: 'Garaj', subs: [
      { slug: 'usi-sectionale-garaj', name: 'Uși secționale', url: '/pages/usi-de-garaj#usi-sectionale-de-garaj' },
      { slug: 'usi-rulou-garaj', name: 'Uși rulou', url: '/pages/usi-de-garaj#usi-rulou-de-garaj' }
    ]}
  ]);

  function buildMegaMenuStyles() {
    if (document.getElementById('dcm-mega-styles')) return;
    const css = [
      /* Mega menu — desktop hover dropdown + mobile multilevel drawer */
      '.dcm-mega-trigger { position: relative; display: inline-flex; align-items: center; gap: 0.4rem; background: transparent; border: 0; padding: 0; font: inherit; color: inherit; cursor: pointer; }',
      '.dcm-mega-trigger .dcm-mega-caret { display: inline-block; width: 10px; height: 10px; border-right: 2px solid currentColor; border-bottom: 2px solid currentColor; transform: rotate(45deg); transition: transform 0.2s ease; margin-left: 0.4rem; margin-bottom: 4px; }',
      '.dcm-mega-trigger[aria-expanded="true"] .dcm-mega-caret { transform: rotate(-135deg); margin-bottom: -2px; }',
      /* Desktop: dropdown panel below the nav link */
      '.dcm-mega { position: absolute; top: calc(100% + 14px); left: 50%; transform: translateX(-50%) translateY(-8px); min-width: 320px; max-width: 420px; background: #fafaf7; color: #0e0e10; border: 2px solid #0e0e10; box-shadow: 8px 8px 0 0 #f7941d; opacity: 0; visibility: hidden; transition: opacity 0.18s ease, transform 0.18s ease, visibility 0s linear 0.15s; z-index: 200; pointer-events: none; }',
      '.dcm-mega--single { min-width: 280px; max-width: 360px; left: 0; transform: translateX(0) translateY(-8px); }',
      '.header__nav-item--mega:hover .dcm-mega--single, .dcm-mega--single.is-open { transform: translateX(0) translateY(0); }',
      /* Single-cat dropdown shows subs immediately (no level-1 navigation) */
      '.dcm-mega--single .dcm-mega__sub { display: block !important; }',
      '.dcm-mega--single .dcm-mega__sub ul { padding: 0.5rem 0 !important; }',
      /* Tighten the nav row so 8 category buttons fit at 1440px */
      '.header__nav-list { gap: 0.4rem !important; flex-wrap: nowrap; }',
      '.header__nav-list .dcm-mega-trigger, .header__nav-list .header__nav-link { font-size: 1.25rem !important; letter-spacing: 0.04em !important; padding: 0.6rem 0.7rem !important; white-space: nowrap; }',
      '.header__nav-list .dcm-mega-trigger .dcm-mega-caret { width: 7px; height: 7px; margin-left: 0.3rem; border-width: 1.5px; }',
      '@media (max-width: 1280px) { .header__nav-list .dcm-mega-trigger, .header__nav-list .header__nav-link { font-size: 1.15rem !important; padding: 0.5rem 0.5rem !important; } }',
      /* Wider invisible bridge between trigger and panel so a slow cursor
         dragging downward never falls into a hover-gap */
      '.dcm-mega::before { content: ""; position: absolute; top: -20px; left: -40px; right: -40px; height: 22px; }',
      /* Also extend a tall safe zone behind the trigger itself */
      '.header__nav-item--mega::after { content: ""; position: absolute; left: 0; right: 0; bottom: -20px; height: 20px; pointer-events: auto; }',
      '.header__nav-item--mega:hover .dcm-mega, .header__nav-item--mega:focus-within .dcm-mega, .dcm-mega.is-open { opacity: 1; visibility: visible; transform: translateX(-50%) translateY(0); pointer-events: auto; transition: opacity 0.18s ease, transform 0.18s ease, visibility 0s linear 0s; }',
      '.dcm-mega__panels { position: relative; overflow: hidden; }',
      '.dcm-mega__panel ul { list-style: none; margin: 0; padding: 0; }',
      '.dcm-mega__panel li { display: block; }',

      /* ── Categories list (level 1) — clean simple rows like the original ── */
      '.dcm-mega__cats { padding: 0.8rem 0; }',
      '.dcm-mega__cats button { display: flex; align-items: center; justify-content: space-between; gap: 1.2rem; width: 100%; padding: 1.2rem 2rem; background: transparent; border: 0; color: #0e0e10; text-align: left; cursor: pointer; font-family: "Bebas Neue", "Inter", sans-serif; font-size: 1.5rem; letter-spacing: 0.04em; line-height: 1.2; transition: background 0.15s ease, color 0.15s ease; }',
      '.dcm-mega__cats button:hover { background: #0e0e10; color: #f7941d; }',
      '.dcm-mega__cats button .dcm-mega__arrow { color: #f7941d; font-weight: 700; opacity: 0.7; transition: transform 0.18s ease, opacity 0.18s ease; }',
      '.dcm-mega__cats button:hover .dcm-mega__arrow { transform: translateX(3px); opacity: 1; }',

      /* ── Subcategories list (level 2) — card-row design with orange bar ── */
      '.dcm-mega__sub { padding: 0.6rem; }',
      '.dcm-mega__sub ul { display: flex; flex-direction: column; gap: 2px; }',
      '.dcm-mega__sub ul li { background: rgba(14, 14, 16, 0.025); }',
      '.dcm-mega__sub ul li:nth-child(odd) { background: rgba(14, 14, 16, 0.05); }',
      '.dcm-mega__sub a { position: relative; display: flex; align-items: center; gap: 1.2rem; width: 100%; padding: 1rem 1.4rem; background: transparent; border: 0; color: #0e0e10; text-align: left; text-decoration: none; cursor: pointer; transition: background 0.18s ease, transform 0.18s ease; }',
      '.dcm-mega__sub a::before { content: ""; flex: 0 0 auto; width: 3px; align-self: stretch; min-height: 22px; background: #f7941d; transition: background 0.18s ease; }',
      '.dcm-mega__sub a > span:first-of-type:not(.dcm-mega__arrow) { flex: 1 1 auto; min-width: 0; font-family: "Bebas Neue", "Inter", sans-serif; font-size: 1.6rem; line-height: 1.2; letter-spacing: 0.06em; text-transform: uppercase; font-weight: 400; color: #0e0e10; }',
      '.dcm-mega__sub a .dcm-mega__arrow { color: #0e0e10; opacity: 0.45; font-size: 1.4rem; line-height: 1; flex: 0 0 auto; transition: transform 0.18s ease, opacity 0.18s ease; }',
      '.dcm-mega__sub a:hover { background: rgba(247, 148, 29, 0.10); }',
      '.dcm-mega__sub a:hover::before { background: #0e0e10; }',
      '.dcm-mega__sub a:hover .dcm-mega__arrow { transform: translateX(4px); opacity: 1; }',
      /* Subcategory panel slide-in */
      '.dcm-mega__sub { display: none; }',
      '.dcm-mega.is-sub-open .dcm-mega__cats { display: none; }',
      '.dcm-mega.is-sub-open .dcm-mega__sub.is-active { display: block; animation: dcmMegaSlide 0.24s ease both; }',
      '@keyframes dcmMegaSlide { from { transform: translateX(20px); opacity: 0; } to { transform: translateX(0); opacity: 1; } }',
      '.dcm-mega__back { display: flex !important; align-items: center; gap: 0.8rem; padding: 1rem 2rem !important; font-size: 1.2rem !important; letter-spacing: 0.14em !important; text-transform: uppercase; color: #0e0e10 !important; border-bottom: 1px solid rgba(14,14,16,0.1) !important; opacity: 0.7; }',
      '.dcm-mega__back:hover { background: transparent !important; color: #f7941d !important; opacity: 1; }',
      '.dcm-mega__back .dcm-mega__back-arrow { display: inline-block; width: 8px; height: 8px; border-left: 2px solid currentColor; border-bottom: 2px solid currentColor; transform: rotate(45deg); }',
      '.dcm-mega__sub-title { padding: 1.4rem 2rem 0.8rem; font-family: "Bebas Neue", "Inter", sans-serif; font-size: 1.8rem; letter-spacing: 0.04em; color: #0e0e10; }',
      '.dcm-mega__sub-title::after { content: ""; display: block; width: 32px; height: 3px; background: #f7941d; margin-top: 0.6rem; }',
      /* ── Mobile drawer mega menu — clean card-row design ──
         Goal: no possible orange-on-cream (iOS sticky-hover bug), generous
         tap targets, clear visual hierarchy with strong typography. */
      '@media (max-width: 989px) {',
      /* Reset mega panel layout */
      '  html body .mobile-menu .dcm-mega { position: static !important; transform: none !important; min-width: 0; max-width: none; box-shadow: none !important; border: 0 !important; opacity: 1; visibility: visible; pointer-events: auto; background: transparent !important; padding: 0; margin: 0; }',
      '  html body .mobile-menu .dcm-mega::before { display: none; }',
      /* Trigger row */
      '  html body .mobile-menu .dcm-mega-trigger { width: 100%; display: flex; align-items: center; justify-content: space-between; padding: 1.6rem 0; font-family: "Bebas Neue", "Inter", sans-serif; font-size: 2.8rem; line-height: 1.1; letter-spacing: 0.02em; color: #0e0e10 !important; background: transparent !important; border: 0; cursor: pointer; -webkit-tap-highlight-color: transparent; }',
      '  html body .mobile-menu .dcm-mega-trigger .dcm-mega-caret { width: 14px; height: 14px; border-color: #0e0e10 !important; }',
      /* Hidden until tapped */
      '  html body .mobile-menu .dcm-mega { display: none; }',
      '  html body .mobile-menu .dcm-mega.is-open { display: block; margin: 0.4rem -0.4rem 1.2rem; padding: 0.8rem 0; border-radius: 12px; background: rgba(14, 14, 16, 0.04); }',

      /* ── Categories list (level 1) — simple drawer-style rows ── */
      '  html body .mobile-menu .dcm-mega__cats button {',
      '    width: 100%; display: flex; align-items: center; justify-content: space-between; gap: 1.2rem;',
      '    padding: 1.4rem 1.6rem; background: transparent !important; border: 0;',
      '    font-family: "Bebas Neue", "Inter", sans-serif; font-size: 2rem; line-height: 1.15;',
      '    letter-spacing: 0.04em; text-transform: uppercase;',
      '    color: #0e0e10 !important; text-align: left; cursor: pointer;',
      '    -webkit-tap-highlight-color: transparent;',
      '  }',
      '  html body .mobile-menu .dcm-mega__cats button .dcm-mega__arrow { color: #f7941d !important; font-weight: 700; opacity: 0.85; flex: 0 0 auto; transition: transform 0.18s ease; }',
      '  html body .mobile-menu .dcm-mega__cats button:hover .dcm-mega__arrow,',
      '  html body .mobile-menu .dcm-mega__cats button.dcm-tap-active .dcm-mega__arrow { transform: translateX(4px); }',
      '  html body .mobile-menu .dcm-mega__cats button:hover,',
      '  html body .mobile-menu .dcm-mega__cats button.dcm-tap-active { color: #0e0e10 !important; }',

      /* ── Subcategories list (level 2) — card rows with orange bar ── */
      '  html body .mobile-menu .dcm-mega__sub a {',
      '    position: relative; display: flex; align-items: center; gap: 1.4rem;',
      '    width: 100%; padding: 1.4rem 1.6rem;',
      '    background: transparent !important; border: 0;',
      '    text-align: left; text-decoration: none; cursor: pointer;',
      '    color: #0e0e10 !important;',
      '    -webkit-tap-highlight-color: transparent;',
      '    transition: background 0.18s ease, transform 0.18s ease;',
      '  }',
      '  html body .mobile-menu .dcm-mega__sub a::before {',
      '    content: ""; flex: 0 0 auto;',
      '    width: 3px; align-self: stretch; min-height: 24px;',
      '    background: #f7941d;',
      '    transition: background 0.18s ease;',
      '  }',
      '  html body .mobile-menu .dcm-mega__sub a > span:first-of-type:not(.dcm-mega__arrow) {',
      '    flex: 1 1 auto; min-width: 0;',
      '    font-family: "Bebas Neue", "Inter", sans-serif !important;',
      '    font-size: 1.9rem !important; line-height: 1.2 !important;',
      '    letter-spacing: 0.06em !important; text-transform: uppercase !important;',
      '    font-weight: 400 !important;',
      '    color: #0e0e10 !important;',
      '  }',
      '  html body .mobile-menu .dcm-mega__sub a .dcm-mega__arrow { flex: 0 0 auto; color: #0e0e10 !important; opacity: 0.45; font-size: 1.6rem; line-height: 1; transition: transform 0.18s ease, opacity 0.18s ease; }',
      '  html body .mobile-menu .dcm-mega__sub ul { display: flex; flex-direction: column; gap: 2px; }',
      '  html body .mobile-menu .dcm-mega__sub ul li { background: rgba(255, 255, 255, 0.6); }',
      '  html body .mobile-menu .dcm-mega__sub ul li:nth-child(odd) { background: rgba(255, 255, 255, 0.85); }',
      /* Sub: lock color + press feedback */
      '  html body .mobile-menu .dcm-mega__sub a:hover,',
      '  html body .mobile-menu .dcm-mega__sub a:active,',
      '  html body .mobile-menu .dcm-mega__sub a:focus,',
      '  html body .mobile-menu .dcm-mega__sub a.dcm-tap-active { color: #0e0e10 !important; background: rgba(247, 148, 29, 0.10) !important; }',
      '  html body .mobile-menu .dcm-mega__sub a:active::before,',
      '  html body .mobile-menu .dcm-mega__sub a.dcm-tap-active::before { background: #0e0e10; }',
      '  html body .mobile-menu .dcm-mega__sub a:active .dcm-mega__arrow,',
      '  html body .mobile-menu .dcm-mega__sub a.dcm-tap-active .dcm-mega__arrow { transform: translateX(4px); opacity: 1; }',

      /* Back row: small uppercase label, not a list-item card */
      '  html body .mobile-menu .dcm-mega__back { display: flex !important; align-items: center; gap: 0.8rem; width: auto !important; padding: 1rem 1.6rem 0.6rem !important; background: transparent !important; border: 0 !important; font-family: "Inter", sans-serif !important; font-size: 1.2rem !important; font-weight: 600 !important; letter-spacing: 0.18em !important; text-transform: uppercase; color: rgba(14,14,16,0.5) !important; cursor: pointer; }',
      '  html body .mobile-menu .dcm-mega__back:active { color: #0e0e10 !important; }',
      '  html body .mobile-menu .dcm-mega__back .dcm-mega__back-arrow { border-color: currentColor; }',

      /* Section title above the subcategory list */
      '  html body .mobile-menu .dcm-mega__sub-title { padding: 0.6rem 1.6rem 1rem; margin: 0; font-family: "Bebas Neue", "Inter", sans-serif; font-size: 2.4rem; line-height: 1.05; letter-spacing: 0.02em; color: #0e0e10 !important; }',
      '  html body .mobile-menu .dcm-mega__sub-title::after { content: ""; display: block; width: 36px; height: 3px; background: #f7941d; margin-top: 0.6rem; }',
      '}',
      /* Hide on very small if needed */
      '.dcm-mega__cats li button { font-weight: 500; }',
      '.dcm-mega__cats li button:hover { background: #0e0e10; color: #f7941d; }'
    ].join('\n');
    const style = document.createElement('style');
    style.id = 'dcm-mega-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function buildMegaPanelsHTML() {
    const cats = DCM_CATEGORIES.map(function (c) {
      return '<li><button type="button" class="dcm-mega-cat-btn" data-cat="' + c.slug + '">' +
        '<span>' + c.name + '</span>' +
        '<span class="dcm-mega__arrow">→</span>' +
        '</button></li>';
    }).join('');
    const subs = DCM_CATEGORIES.map(function (c) {
      const items = c.subs.map(function (s) {
        return '<li><a href="/collections/' + s.slug + '"><span>' + s.name + '</span><span>→</span></a></li>';
      }).join('');
      return '<div class="dcm-mega__panel dcm-mega__sub" data-sub="' + c.slug + '">' +
        '<button type="button" class="dcm-mega__back" data-mega-back>' +
        '<span class="dcm-mega__back-arrow"></span><span>' + (DCM_LOCALE === 'en' ? 'Back' : DCM_LOCALE === 'de' ? 'Zurück' : 'Înapoi') + '</span>' +
        '</button>' +
        '<h3 class="dcm-mega__sub-title">' + c.name + '</h3>' +
        '<ul>' + items + '</ul>' +
        '</div>';
    }).join('');
    return '<div class="dcm-mega" data-dcm-mega>' +
      '<div class="dcm-mega__panels">' +
        '<div class="dcm-mega__panel dcm-mega__cats"><ul>' + cats + '</ul></div>' +
        subs +
      '</div></div>';
  }

  function wireMegaMenu(root) {
    const mega = root.querySelector('[data-dcm-mega]');
    const trigger = root.querySelector('.dcm-mega-trigger');
    if (!mega || !trigger) return;
    function showSub(slug) {
      mega.classList.add('is-sub-open');
      mega.querySelectorAll('.dcm-mega__sub').forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-sub') === slug);
      });
    }
    function showCats() {
      mega.classList.remove('is-sub-open');
      mega.querySelectorAll('.dcm-mega__sub').forEach(function (s) { s.classList.remove('is-active'); });
    }
    mega.addEventListener('click', function (e) {
      const catBtn = e.target.closest('.dcm-mega-cat-btn');
      if (catBtn) {
        e.preventDefault();
        showSub(catBtn.getAttribute('data-cat'));
        // Pin the menu open after entering a sub. Otherwise on desktop the
        // shorter sub-panel may not be under the cursor anymore (categories
        // panel is taller than 2-item subs) and :hover would close it.
        mega.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        return;
      }
      const back = e.target.closest('[data-mega-back]');
      if (back) { e.preventDefault(); showCats(); return; }
    });
    // Mobile: trigger toggles open/close
    trigger.addEventListener('click', function (e) {
      const isMobile = window.innerWidth <= 989;
      if (!isMobile) return; // desktop uses :hover
      e.preventDefault();
      const open = mega.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) showCats();
    });
    // Desktop: ESC closes if focus inside, click outside closes any sub-open
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) { mega.classList.remove('is-open'); showCats(); trigger.setAttribute('aria-expanded', 'false'); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { mega.classList.remove('is-open'); showCats(); trigger.setAttribute('aria-expanded', 'false'); }
    });
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="#"]');
      if (!a) return;
      var url = new URL(a.href, location.href);
      if (url.pathname !== location.pathname || !url.hash) return;
      var el = document.getElementById(url.hash.slice(1));
      if (!el) return;
      e.preventDefault();
      mega.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', url.hash);
    });
  }

  function buildSingleCatPanelHTML(cat) {
    const items = cat.subs.map(function (s) {
      return '<li><a href="' + (s.url || '/pages/' + s.slug) + '"><span>' + s.name + '</span><span class="dcm-mega__arrow">→</span></a></li>';
    }).join('');
    return '<div class="dcm-mega dcm-mega--single" data-dcm-mega>' +
      '<div class="dcm-mega__panel dcm-mega__sub is-active" data-sub="' + cat.slug + '">' +
        '<ul>' + items + '</ul>' +
      '</div>' +
      '</div>';
  }

  function dcmScrollToCategories(targetEl) {
    // For a specific card target, we still scroll vertically to the
    // *section* (so the heading stays visible) — and only scroll the
    // horizontal slider to align the target card.
    var card = (targetEl && targetEl.classList && targetEl.classList.contains('cat-card')) ? targetEl : null;
    var section = card ? card.closest('.cat-split') : null;
    var target = section || targetEl || document.querySelector('.cat-split, [id$="__categories"]');
    if (!target) return false;
    var nav = document.querySelector('.header, header[role="banner"]');
    var headerH = (nav && nav.offsetHeight) || 80;
    var top = target.getBoundingClientRect().top + window.scrollY - headerH - 20;
    window.scrollTo({ top: top, behavior: 'smooth' });
    if (card) {
      var grid = card.closest('.cat-split__grid');
      if (grid && grid.scrollWidth > grid.clientWidth) {
        var styles = window.getComputedStyle(grid);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        var left = Math.max(0, card.offsetLeft - gap);
        var max = grid.scrollWidth - grid.clientWidth;
        if (left > max) left = max;
        try { grid.scrollTo({ left: left, behavior: 'smooth' }); }
        catch (_) { grid.scrollLeft = left; }
      }
    }
    return true;
  }

  // Cross-page nav: when arriving at home with #categorii or #cat-{slug},
  // scroll to either the categories section or the specific card.
  // Retry several times because .cat-split / .cat-card IDs are set after
  // dcmRegister setup, and the section can be lazy-rendered by Shopify.
  // Stop retrying as soon as the user touches the scroll — otherwise the
  // later retries yank them back if they're already trying to leave.
  // Track whether the auto-scroll is "done" so further retries become no-ops.
  // Done = either we landed within 50px of target, or the user scrolled
  // significantly away from where we last placed them (intent to leave).
  var dcmHashDone = false;
  var dcmHashLastSetY = -1;

  function dcmHashTargetTop() {
    var hash = window.location.hash;
    var target = null;
    if (hash === '#categorii') {
      target = document.querySelector('.cat-split, [id$="__categories"]');
    } else if (/^#cat-[a-z0-9-]+$/i.test(hash)) {
      dcmIdCatCards();
      var el = document.getElementById(hash.slice(1));
      if (el) target = el.closest('.cat-split') || el;
    }
    if (!target) return null;
    var nav = document.querySelector('.header, header[role="banner"]');
    var headerH = (nav && nav.offsetHeight) || 80;
    return { top: target.getBoundingClientRect().top + window.scrollY - headerH - 20, hash: hash };
  }

  function dcmHashCheck() {
    if (dcmHashDone) return;
    var t = dcmHashTargetTop();
    if (!t) return;

    // If user has scrolled noticeably away from where we last placed
    // them, treat that as intent to leave — stop trying to yank back.
    // (We compare against where WE last scrolled to, not the target,
    // so the initial mid-animation samples don't count as "moved".)
    if (dcmHashLastSetY >= 0 && Math.abs(window.scrollY - dcmHashLastSetY) > 120) {
      dcmHashDone = true;
      return;
    }

    // Already close enough to target → done.
    if (Math.abs(window.scrollY - t.top) < 50) {
      dcmHashDone = true;
      return;
    }

    var hash = t.hash;
    if (hash === '#categorii') {
      dcmScrollToCategories();
    } else {
      var el = document.getElementById(hash.slice(1));
      if (el) dcmScrollToCategories(el);
    }
    dcmHashLastSetY = t.top;
  }

  function dcmStartHashRetries() {
    dcmHashDone = false;
    dcmHashLastSetY = -1;
    [100, 300, 600, 1200, 2500].forEach(function (ms) { setTimeout(dcmHashCheck, ms); });
    document.addEventListener('DOMContentLoaded', dcmHashCheck);
    window.addEventListener('load', function () {
      dcmHashCheck();
      setTimeout(dcmHashCheck, 250);
    });
  }
  if (window.location.hash === '#categorii' || /^#cat-[a-z0-9-]+$/i.test(window.location.hash)) {
    dcmStartHashRetries();
  }
  window.addEventListener('hashchange', function () {
    dcmHashDone = false;
    dcmHashLastSetY = -1;
    dcmHashCheck();
  });

  function wireSingleMega(root) {
    const mega = root.querySelector('[data-dcm-mega]');
    const trigger = root.querySelector('.dcm-mega-trigger');
    if (!mega || !trigger) return;
    // a11y: give the panel an id and point the trigger at it. aria-haspopup is
    // already set in the markup; aria-expanded is kept in sync below.
    if (!mega.id) { mega.id = 'dcm-mega-panel-' + (wireSingleMega._uid = (wireSingleMega._uid || 0) + 1); }
    trigger.setAttribute('aria-controls', mega.id);
    // Keep aria-expanded honest. On desktop the panel opens purely via CSS
    // (:hover / :focus-within) with no JS click, so without this the trigger
    // would always announce aria-expanded="false" even while the menu is open.
    // This ONLY updates the attribute — the visual open/close stays CSS-driven
    // and the mouse + keyboard interaction is unchanged.
    function syncExpanded() {
      var desktop = window.innerWidth > 989;
      var open = mega.classList.contains('is-open') || (desktop && (root.matches(':hover') || root.contains(document.activeElement)));
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    root.addEventListener('mouseenter', syncExpanded);
    root.addEventListener('mouseleave', function () { setTimeout(syncExpanded, 0); });
    root.addEventListener('focusin', syncExpanded);
    root.addEventListener('focusout', function () { setTimeout(syncExpanded, 0); });
    // Mobile: tap toggles dropdown, never navigates.
    // Desktop: the anchor's native href handles navigation; the dropdown shows
    // on hover/focus via CSS, so no JS open is needed there.
    trigger.addEventListener('click', function (e) {
      if (window.innerWidth > 989) return; // desktop: let anchor click through
      e.preventDefault();
      mega.classList.toggle('is-open');
      syncExpanded();
    });
  }

  function injectDesktopMega() {
    const navList = document.querySelector('.header__nav-list');
    if (!navList) return;
    if (navList.dataset.dcmMultiMega === '1') return; // already done
    // Group: cats whose slug starts with "usi-" go under a single USI parent;
    // the rest get their own top-level dropdown trigger.
    var usiCats = DCM_CATEGORIES.filter(function (c) { return /^usi-/.test(c.slug); });
    var otherCats = DCM_CATEGORIES.filter(function (c) { return !/^usi-/.test(c.slug); });

    // USI parent dropdown — flat list of the 5 Uși categories as direct links
    // to content pages (not collection pages).
    var usiItems = usiCats.map(function (c) {
      return '<li><a href="/pages/' + c.slug + '"><span>' + c.name + '</span><span class="dcm-mega__arrow">→</span></a></li>';
    }).join('');
    // Anchor href to homepage categories section. Native browser nav
    // handles desktop click. On mobile, wireSingleMega's handler
    // preventDefault()s and toggles the dropdown instead.
    var __homePrefix = DCM_LOCALE === 'ro' ? '' : '/' + DCM_LOCALE;
    var __catsHref = __homePrefix + '/#categorii';
    var usiHtml = '<li class="header__nav-item header__nav-item--mega" style="position:relative">' +
      '<a href="' + __catsHref + '" class="header__nav-link dcm-mega-trigger" aria-haspopup="true" aria-expanded="false">' +
        '<span>' + (DCM_LOCALE === 'en' ? 'Doors' : DCM_LOCALE === 'de' ? 'Türen' : 'Uși') + '</span><span class="dcm-mega-caret"></span>' +
      '</a>' +
      '<div class="dcm-mega dcm-mega--single" data-dcm-mega>' +
        '<div class="dcm-mega__panel dcm-mega__sub is-active" data-sub="usi">' +
          '<ul>' + usiItems + '</ul>' +
        '</div>' +
      '</div>' +
    '</li>';

    var otherHtml = otherCats.map(function (c) {
      return '<li class="header__nav-item header__nav-item--mega" style="position:relative">' +
        '<a href="' + __catsHref + '" class="header__nav-link dcm-mega-trigger" aria-haspopup="true" aria-expanded="false">' +
          '<span>' + c.name + '</span><span class="dcm-mega-caret"></span>' +
        '</a>' +
        buildSingleCatPanelHTML(c) +
      '</li>';
    }).join('');

    // DCM_HIDE_MAGAZIN — Magazin page is unpublished for now; drop the link.
    navList.innerHTML = usiHtml + otherHtml;
    navList.dataset.dcmMultiMega = '1';
    navList.dataset.dcmNavReady = '';
    navList.querySelectorAll('.header__nav-item--mega').forEach(wireSingleMega);
    document.addEventListener('click', function (e) {
      if (!navList.contains(e.target)) {
        navList.querySelectorAll('.dcm-mega.is-open').forEach(function (m) { m.classList.remove('is-open'); });
        navList.querySelectorAll('.dcm-mega-trigger').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      }
    });
  }

  function injectMobileMega() {
    const mobileList = document.querySelector('.mobile-menu__list');
    if (!mobileList) return;
    if (mobileList.dataset.dcmMultiMega === '1') return;
    const items = Array.from(mobileList.querySelectorAll('li'));
    // Marker first (locale-independent), fall back to RO text match for older builds
    var portfolioLi = mobileList.querySelector('[data-dcm-portfolio-marker]');
    if (!portfolioLi) {
      portfolioLi = items.find(function (li) {
        return /portofoliu|portfolio/i.test(li.textContent);
      });
    }
    if (!portfolioLi) return;
    // Replace the single Portofoliu li with one li per category
    const sib = portfolioLi.nextSibling;
    const parent = portfolioLi.parentNode;
    portfolioLi.remove();
    var usiCats = DCM_CATEGORIES.filter(function (c) { return /^usi-/.test(c.slug); });
    var otherCats = DCM_CATEGORIES.filter(function (c) { return !/^usi-/.test(c.slug); });

    // USI parent (mobile) — accordion of 5 direct page links (not collections)
    var usiLi = document.createElement('li');
    usiLi.className = 'mobile-menu__item';
    var usiItems = usiCats.map(function (c) {
      return '<li><a href="/pages/' + c.slug + '"><span>' + c.name + '</span><span class="dcm-mega__arrow">→</span></a></li>';
    }).join('');
    usiLi.innerHTML =
      '<button type="button" class="dcm-mega-trigger" aria-haspopup="true" aria-expanded="false">' +
        '<span>' + (DCM_LOCALE === 'en' ? 'Doors' : DCM_LOCALE === 'de' ? 'Türen' : 'Uși') + '</span><span class="dcm-mega-caret"></span>' +
      '</button>' +
      '<div class="dcm-mega dcm-mega--single" data-dcm-mega>' +
        '<div class="dcm-mega__panel dcm-mega__sub is-active" data-sub="usi">' +
          '<ul>' + usiItems + '</ul>' +
        '</div>' +
      '</div>';
    parent.insertBefore(usiLi, sib);
    wireSingleMega(usiLi);

    otherCats.forEach(function (c) {
      const li = document.createElement('li');
      li.className = 'mobile-menu__item';
      li.innerHTML =
        '<button type="button" class="dcm-mega-trigger" aria-haspopup="true" aria-expanded="false">' +
          '<span>' + c.name + '</span><span class="dcm-mega-caret"></span>' +
        '</button>' +
        buildSingleCatPanelHTML(c);
      parent.insertBefore(li, sib);
      wireSingleMega(li);
    });
    mobileList.dataset.dcmMultiMega = '1';
  }

  function setupMegaMenu() {
    buildMegaMenuStyles();
    injectDesktopMega();
    injectMobileMega();
    // DCM_NAV_RELABEL — patch trigger labels at runtime (works around
    // shopify silently reverting `short:` edits inside DCM_CATEGORIES).
    var DCM_NAV_RELABEL = {};
    document.querySelectorAll('.header__nav-list .dcm-mega-trigger > span:first-child').forEach(function (sp) {
      var key = sp.textContent.trim().toLowerCase();
      if (DCM_NAV_RELABEL[key]) sp.textContent = DCM_NAV_RELABEL[key];
    });
    // DCM_NAV_TIGHTEN — late style injection so 9 nav items + logo + CTA fit
    // (the rule inside buildMegaMenuStyles tends to get reverted by shopify).
    if (!document.getElementById('dcm-nav-tighten')) {
      var ts = document.createElement('style');
      ts.id = 'dcm-nav-tighten';
      ts.textContent =
        'html body .header__nav-list{gap:0.3rem !important;flex-wrap:nowrap}' +
        'html body .header__nav-list .dcm-mega-trigger,html body .header__nav-list .header__nav-link{font-size:1.05rem !important;padding:0.4rem 0.35rem !important;letter-spacing:0.03em !important;white-space:nowrap}' +
        'html body .header__nav-list .dcm-mega-trigger .dcm-mega-caret{width:6px !important;height:6px !important;margin-left:0.2rem !important;border-width:1.5px !important}' +
        'html body .header__logo{flex:0 0 auto !important;min-width:88px !important}' +
        'html body .header__inner{gap:0.5rem !important}' +
        '@media (max-width:1320px){html body .header__nav-list .dcm-mega-trigger,html body .header__nav-list .header__nav-link{font-size:0.95rem !important;padding:0.3rem 0.25rem !important}}';
      document.head.appendChild(ts);
    }
  }
  dcmRegister(setupMegaMenu);
  // Re-inject when mobile drawer opens (it may render lazily)
  document.addEventListener('click', function (e) {
    if (e.target.closest('.header__menu-btn, [data-menu-open]')) {
      setTimeout(setupMegaMenu, 50);
    }
  });

  // DCM_NAV_BIGGER — extra-late nav font override that wins specificity over
  // dcm-nav-tighten (which shopify keeps reverting to small values).
  (function dcmNavBigger() {
    if (document.getElementById('dcm-nav-bigger')) return;
    var s = document.createElement('style');
    s.id = 'dcm-nav-bigger';
    s.textContent =
      'html body header.header .header__nav-list .dcm-mega-trigger,' +
      'html body header.header .header__nav-list .header__nav-link{' +
        'font-size:1.4rem !important;padding:0.5rem 0.8rem !important;letter-spacing:0.03em !important' +
      '}' +
      /* Align header__inner horizontal padding with .hero__inner so logo and hero heading share the same left edge */
      '@media (min-width:750px){html body .header__inner{padding-left:48px !important;padding-right:48px !important}}';
    document.head.appendChild(s);
  })();

  // DCM_REMOVE_RATES_GARANTIE — sweep references to "plată în rate" / "garanție 5 ani"
  // from everywhere on the site EXCEPT the 4 trust cards directly under the hero.
  (function dcmRemoveRatesGarantie() {
    var RX = /(plat[ăa] (?:și |si )?(?:în|in) rate|rate f[ăa]r[ăa] dob[âa]nd[ăa]|garan[țt]ie 5(?:\s+ani)?|garan[țt]ie extin[șs]?[ăa]?\s*5)/i;
    function isInTrustCards(el) {
      // Keep elements inside the trust-strip section (the 4 feature cards under hero)
      return !!el.closest('.trust-strip, .trust-cell, .scheme-paper.trust-strip, [class*="trust-strip"]');
    }
    function sweep() {
      // Marquee items
      document.querySelectorAll('.dcm-marquee-section .dcm-bm__item, .dcm-bm__item, [data-marquee-strip] [class*="item"]').forEach(function (el) {
        if (RX.test(el.textContent)) {
          // Also remove the separator next to it
          var sep = el.nextElementSibling;
          el.remove();
          if (sep && /sep/i.test(sep.className || '')) sep.remove();
        }
      });
      // FAQ accordion items (both injected and section)
      document.querySelectorAll('.dcm-x-faq details, .dcm-faq-item, details').forEach(function (det) {
        var sum = det.querySelector('summary, .dcm-faq-item__q');
        var text = (sum ? sum.textContent : det.textContent) || '';
        if (RX.test(text)) det.remove();
      });
      // Quote-CTA bullets
      document.querySelectorAll('.quote-cta__bullet').forEach(function (b) {
        if (RX.test(b.textContent)) b.style.setProperty('display', 'none', 'important');
      });
      // Quote form help/microcopy items
      document.querySelectorAll('[class*="quote-form"] [class*="help"], .dcm-form-help, [data-form-help], .quote-form__help').forEach(function (el) {
        if (RX.test(el.textContent)) el.style.setProperty('display', 'none', 'important');
      });
      // Generic page bullets / list items (despre-noi etc.) — but never inside trust cards
      document.querySelectorAll('li, .dcm-bullet, .dcm-list__item, .dcm-feature').forEach(function (el) {
        if (isInTrustCards(el)) return;
        var text = el.textContent || '';
        if (RX.test(text) && text.length < 120) {
          el.style.setProperty('display', 'none', 'important');
        }
      });
    }
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }
    ready(function () {
      sweep();
      // Re-run after late JS injections (mega menu, hero slideshow, etc.)
      setTimeout(sweep, 300);
      setTimeout(sweep, 1200);
      // Watch for late-rendered content
      var mo = new MutationObserver(function () { sweep(); });
      mo.observe(document.body, { childList: true, subtree: true });
    });
  })();

  // DCM_CERE_OFERTA_PATCH — runtime DOM cleanup for the cere-oferta page since
  // process.liquid + quote-form.liquid keep getting reverted by Shopify.
  (function dcmCereOfertaPatch() {
    if (!document.getElementById('dcm-cere-css')) {
      var st = document.createElement('style');
      st.id = 'dcm-cere-css';
      st.textContent =
        // Process: orange bg with dark cards — separates from the dark footer.
        'html body .process{background:#f7941d !important;color:#0e0e10 !important}' +
        'html body .process .process__head h2,html body .process .process__head .eyebrow{color:#0e0e10 !important}' +
        'html body .process .lead,html body .process .process__head .lead{color:rgba(14,14,16,0.78) !important}' +
        'html body .process .process__step{background:#0e0e10 !important}' +
        'html body .process .process__step-text{color:rgba(244,243,239,0.78) !important}' +
        'html body .process .process__step-title{color:#fafaf7 !important}' +
        'html body .process .process__step-num{display:none !important}';
      document.head.appendChild(st);
    }
    function patch() {
      // 1) PAS labels: collapse "PAS 01 / 04" → "PAS 1" (i18n: STEP/SCHRITT)
      var stepLbl = DCM_LOCALE === 'en' ? 'STEP' : DCM_LOCALE === 'de' ? 'SCHRITT' : 'PAS';
      document.querySelectorAll('.process__step-num').forEach(function (el) {
        var m = el.textContent.match(/(?:PAS|STEP|SCHRITT)\s*0?(\d+)/i);
        if (m && el.textContent !== stepLbl + ' ' + parseInt(m[1], 10)) {
          el.textContent = stepLbl + ' ' + parseInt(m[1], 10);
        }
      });
      // 2) Phone widget on the cere-oferta intro: replace number + hide hours
      var phoneBox = document.querySelector('.quote-form__intro [class*="eyebrow"]');
      // Find a div inside .quote-form__intro that contains a tel: link
      var intros = document.querySelectorAll('.quote-form__intro > div');
      intros.forEach(function (box) {
        var tel = box.querySelector('a[href^="tel"]');
        if (!tel || box.dataset.dcmPhonePatched) return;
        // Replace number text node with locale-aware "Call us"
        var callLbl = DCM_LOCALE === 'en' ? 'Call us' : DCM_LOCALE === 'de' ? 'Rufen Sie uns an' : 'Sună-ne';
        if (!/sun[ăa]-?ne|call us|rufen sie/i.test(tel.textContent)) {
          tel.textContent = callLbl;
        }
        // Remove the orar paragraph (Lu-Vi 09:00…)
        Array.from(box.querySelectorAll('p')).forEach(function (p) {
          if (/lu[\s\-–]?vi|09:00|orar|s[ăa]\s+09|s[âa]\s+09/i.test(p.textContent)) {
            p.style.setProperty('display', 'none', 'important');
          }
        });
        // Add colleague's 2nd number. The visible number in this box is painted by
        // a CSS ::after on the tel link (dcm-overrides-v6.css), so changing the link
        // text does nothing. We clone the link (keeps the exact box styling), point
        // it at the 2nd number, and tag it `.dcm-tel-2` — the CSS then overrides its
        // ::after to show +40 771 054 089. Idempotent (class check) so the
        // MutationObserver re-runs never duplicate it.
        if (!box.querySelector('a.dcm-tel-2')) {
          var tel2 = tel.cloneNode(true);
          tel2.setAttribute('href', 'tel:+40771054089');
          tel2.classList.add('dcm-tel-2');
          tel.parentNode.insertBefore(tel2, tel.nextSibling);
        }
        box.dataset.dcmPhonePatched = '1';
      });
    }
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }
    ready(function () {
      patch();
      setTimeout(patch, 300);
      setTimeout(patch, 1200);
      new MutationObserver(patch).observe(document.body, { childList: true, subtree: true });
    });
  })();

  // DCM_HEADER_ALIGN — late override: header padding-x mirrors hero breakpoint
  // (≥990 uses 48px, <990 uses 20px). Wins specificity over the rule above
  // which Shopify keeps reverting from 990 back to 750.
  (function dcmHeaderAlign() {
    if (document.getElementById('dcm-header-align')) return;
    var s = document.createElement('style');
    s.id = 'dcm-header-align';
    s.textContent =
      '@media (min-width:990px){html body header.header .header__inner{padding-left:48px !important;padding-right:48px !important}}' +
      '@media (max-width:989px){html body header.header .header__inner{padding-left:20px !important;padding-right:20px !important}}';
    document.head.appendChild(s);
  })();

  // DCM_USI_2LEVEL — patch the Uși dropdown to be 2-level (cat list → click opens
  // sub list with back). Shopify reverts edits to injectDesktopMega/Mobile, so we
  // tear down the rendered single-panel and rebuild as a 2-level mega here.
  (function dcmUsi2Level() {
    function findUsiCats() {
      // DCM_CATEGORIES isn't a global, mirror it from the rendered single Uși panel.
      // Strategy: read the existing 5 anchors and resolve their slugs back to cats.
      // Easier: hard-code the slugs (they don't change). Wrapped in dcmI18nCats
      // so EN/DE labels swap in on /en/* and /de/* URLs.
      return dcmI18nCats([
        { slug: 'usi-industriale',     name: 'Uși Industriale',     subs: [
          { slug: 'usi-sectionale-industriale', name: 'Uși secționale' },
          { slug: 'usi-rulou-industriale', name: 'Uși rulou' },
          { slug: 'usi-rapide', name: 'Uși rapide' },
          { slug: 'usi-batante-industriale', name: 'Uși batante' }
        ]},
        { slug: 'usi-rezistente-la-foc',  name: 'Uși rezistente la foc', subs: [
          { slug: 'usi-pietonale-rezistente-la-foc', name: 'Uși pietonale' },
          { slug: 'usi-culisante-rezistente-la-foc', name: 'Uși culisante' },
          { slug: 'usi-telescopice-rezistente-la-foc', name: 'Uși telescopice' },
          { slug: 'cortine-rezistente-la-foc', name: 'Cortine rezistente la foc' }
        ]},
        { slug: 'usi-pietonale',       name: 'Uși pietonale',       subs: [
          { slug: 'usi-multifunctionale-int-ext', name: 'Uși multifuncționale (int. & ext.)' },
          { slug: 'usi-metalice-interior', name: 'Uși metalice de interior' },
          { slug: 'usi-de-lemn', name: 'Uși de lemn' },
          { slug: 'usi-intrare-casa', name: 'Uși intrare casă' },
          { slug: 'usi-intrare-apartament', name: 'Uși intrare apartament' }
        ]},
        { slug: 'usi-spitale',         name: 'Uși spitale',         subs: [] }
      ]);
    }
    function build2LevelHTML(cats) {
      var l1 = cats.map(function (c) {
        return '<li><button type="button" class="dcm-mega-cat-btn" data-cat="' + c.slug + '">' +
          '<span>' + c.name + '</span><span class="dcm-mega__arrow">→</span></button></li>';
      }).join('');
      var subs = cats.map(function (c) {
        var items = c.subs.map(function (s) {
          return '<li><a href="' + (s.url || '/pages/' + s.slug) + '"><span>' + s.name + '</span><span class="dcm-mega__arrow">→</span></a></li>';
        }).join('');
        return '<div class="dcm-mega__panel dcm-mega__sub" data-sub="' + c.slug + '">' +
          '<button type="button" class="dcm-mega__back" data-mega-back>' +
            '<span class="dcm-mega__back-arrow"></span><span>' + (DCM_LOCALE === 'en' ? 'Back' : DCM_LOCALE === 'de' ? 'Zurück' : 'Înapoi') + '</span></button>' +
          '<h3 class="dcm-mega__sub-title">' + c.name + '</h3>' +
          '<ul>' + items + '</ul></div>';
      }).join('');
      return '<div class="dcm-mega" data-dcm-mega>' +
        '<div class="dcm-mega__panels">' +
          '<div class="dcm-mega__panel dcm-mega__cats"><ul>' + l1 + '</ul></div>' +
          subs +
        '</div></div>';
    }
    function wire(item) {
      var mega = item.querySelector('[data-dcm-mega]');
      var trigger = item.querySelector('.dcm-mega-trigger');
      if (!mega || !trigger || mega.dataset.usiWired === '1') return;
      mega.dataset.usiWired = '1';
      function showSub(slug) {
        mega.classList.add('is-sub-open');
        mega.querySelectorAll('.dcm-mega__sub').forEach(function (s) {
          s.classList.toggle('is-active', s.getAttribute('data-sub') === slug);
        });
      }
      function showCats() {
        mega.classList.remove('is-sub-open');
        mega.querySelectorAll('.dcm-mega__sub').forEach(function (s) { s.classList.remove('is-active'); });
      }
      mega.addEventListener('click', function (e) {
        var btn = e.target.closest('.dcm-mega-cat-btn');
        if (btn) {
          e.preventDefault();
          showSub(btn.getAttribute('data-cat'));
          mega.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          return;
        }
        if (e.target.closest('[data-mega-back]')) { e.preventDefault(); showCats(); }
      });
      trigger.addEventListener('click', function (e) {
        if (window.innerWidth > 989) return;
        e.preventDefault();
        var open = mega.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) showCats();
      });
    }
    function patch() {
      // Disabled. Mobile and desktop both show a flat 5-tile Uși dropdown
      // that links directly to /pages/usi-{slug}. No 2-level expansion.
      return;
    }
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }
    ready(function () {
      patch();
      // re-patch when mobile drawer opens (it lazily renders)
      document.addEventListener('click', function (e) {
        if (e.target.closest('.header__menu-btn, [data-menu-open]')) {
          setTimeout(patch, 100);
        }
      });
      // Observer: catch any rebuild of the nav list
      var nav = document.querySelector('.header__nav-list');
      if (nav) {
        new MutationObserver(function () { patch(); }).observe(nav, { childList: true, subtree: true });
      }
    });
  })();

  // ── Hero slideshow controller (replaces flaky CSS-only animation) ──
  function heroSlideshow() {
    const hero = document.querySelector('.hero');
    if (!hero) return;
    // Desktop-only slides (class hero__slide--desktop-only) drop out of the rotation
    // on phones, so the slideshow never lands on a display:none slide. The matching
    // CSS hide lives inline in sections/hero.liquid.
    const _mobileMq = matchMedia('(max-width: 989px)').matches;
    const slides = Array.from(hero.querySelectorAll('.hero__slide'))
      .filter(s => !(_mobileMq && s.classList.contains('hero__slide--desktop-only')));
    const slideCount = Math.max(slides.length, 1);
    const dotCount = Math.max(slideCount, 3); // always ≥3 dots
    const slideDur = parseFloat(hero.style.getPropertyValue('--slide-dur')) || 5;
    const SLIDE_MS = slideDur * 1000;

    // Build dots container
    let dotsEl = hero.querySelector('.hero__dots');
    if (!dotsEl) {
      dotsEl = document.createElement('div');
      dotsEl.className = 'hero__dots';
      dotsEl.setAttribute('role', 'tablist');
      hero.appendChild(dotsEl);
    }
    dotsEl.innerHTML = '';
    const dotEls = [];
    for (let i = 0; i < dotCount; i++) {
      const d = document.createElement('button');
      d.type = 'button';
      d.className = 'hero__dot';
      d.setAttribute('role', 'tab');
      d.setAttribute('aria-label', 'Slide ' + (i + 1));
      d.dataset.slide = i;
      const fill = document.createElement('span');
      fill.className = 'hero__dot-fill';
      d.appendChild(fill);
      dotsEl.appendChild(d);
      dotEls.push({ btn: d, fill: fill });
    }

    // Reset slide CSS (kill the CSS keyframe animations on slides + dots)
    slides.forEach(s => {
      s.style.animation = 'none';
      s.style.opacity = '0';
      s.style.transition = 'opacity 0.6s ease';
    });
    if (slides[0]) slides[0].style.opacity = '1';

    // Show only one slide; advance with gradual progress fill
    let current = 0;
    let timer = null;
    let progressStart = 0;
    let rafId = null;

    function setDotProgress(i, pct) {
      // pct 0..1 — drives linear-gradient split point on .hero__dot::before
      dotEls[i].btn.style.setProperty('--dot-progress', pct);
    }

    function tickProgress() {
      const elapsed = (performance.now() - progressStart) / SLIDE_MS;
      const pct = Math.min(1, Math.max(0, elapsed));
      setDotProgress(current, pct);
      if (pct < 1) rafId = requestAnimationFrame(tickProgress);
    }

    function paintDots() {
      // Past slides: full. Future slides: empty. Current: starts at 0, animates.
      dotEls.forEach((d, i) => {
        if (i < current) setDotProgress(i, 1);
        else if (i > current) setDotProgress(i, 0);
        else setDotProgress(i, 0);
      });
    }

    function startProgress() {
      if (rafId) cancelAnimationFrame(rafId);
      progressStart = performance.now();
      rafId = requestAnimationFrame(tickProgress);
    }

    // ── Per-slide content swap: read data-heading/lead/highlight from each slide
    //    and update .hero__heading + .hero__lead. Highlighted word gets wrapped
    //    in <span class="hero__heading-mark"> for the orange chip styling. ──
    const headingEl = document.querySelector('.hero__heading');
    const leadEl = document.querySelector('.hero__lead');
    const defaultHeading = headingEl ? (headingEl.dataset.defaultHeading || headingEl.textContent.trim()) : '';
    const defaultLead = leadEl ? (leadEl.dataset.defaultLead || leadEl.textContent.trim()) : '';
    function escapeHtml(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    // Per-slide rotations so each chip feels hand-placed instead of all
    // tilted the same. Stable per slide index (no re-rolling on reload).
    const CHIP_ROTATIONS = ['-0.3deg', '0.25deg', '-0.45deg', '0.18deg', '-0.12deg', '0.35deg', '-0.22deg', '0.4deg'];
    function renderHeadingWithChip(text, highlight, slideIndex) {
      if (!highlight || !text) return escapeHtml(text);
      const lowerText = text.toLowerCase();
      const lowerHl = highlight.toLowerCase();
      const idx = lowerText.indexOf(lowerHl);
      if (idx < 0) return escapeHtml(text);
      const before = text.slice(0, idx);
      const match = text.slice(idx, idx + highlight.length);
      const after = text.slice(idx + highlight.length);
      const rot = CHIP_ROTATIONS[(slideIndex || 0) % CHIP_ROTATIONS.length];
      return escapeHtml(before)
        + '<span class="hero__heading-mark" style="--mark-rotation: ' + rot + ';">' + escapeHtml(match) + '</span>'
        + escapeHtml(after);
    }
    // Polished swap — old text exits UP (fade + lift + slight blur),
    // new text enters from BELOW (snap, then transition to baseline).
    // Coalesces rapid arrow taps so animations don't pile up. Skips
    // the cinematic entirely for reduced-motion users.
    let swapTimer = null;
    let swapInTimer = null;
    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    function clearSwapClasses() {
      if (headingEl) headingEl.classList.remove('is-swapping-out', 'is-swapping-in');
      if (leadEl) leadEl.classList.remove('is-swapping-out', 'is-swapping-in');
    }
    function swapHeroContent(slideEl, slideIndex) {
      if (!slideEl) return;
      const newHeading = (slideEl.dataset.heading || '').trim() || defaultHeading;
      const newLead = (slideEl.dataset.lead || '').trim() || defaultLead;
      const highlight = (slideEl.dataset.highlight || '').trim();
      const applyContent = () => {
        if (headingEl) headingEl.innerHTML = renderHeadingWithChip(newHeading, highlight, slideIndex);
        if (leadEl) leadEl.textContent = newLead;
      };
      // Reduced motion: skip the cinematic and just swap.
      if (reduceMotion) { applyContent(); return; }
      // Cancel any pending swap — last tap wins.
      if (swapTimer) { clearTimeout(swapTimer); swapTimer = null; }
      if (swapInTimer) { clearTimeout(swapInTimer); swapInTimer = null; }
      // Step 1: exit up
      clearSwapClasses();
      if (headingEl) headingEl.classList.add('is-swapping-out');
      if (leadEl) leadEl.classList.add('is-swapping-out');
      swapTimer = setTimeout(() => {
        applyContent();
        // Step 2: snap to "below" entry position (no transition)
        if (headingEl) {
          headingEl.classList.remove('is-swapping-out');
          headingEl.classList.add('is-swapping-in');
        }
        if (leadEl) {
          leadEl.classList.remove('is-swapping-out');
          leadEl.classList.add('is-swapping-in');
        }
        // Step 3: next paint, remove .is-swapping-in so the
        // element transitions UP from below to its baseline state.
        // Double-rAF to guarantee the snap painted before transitioning.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (headingEl) headingEl.classList.remove('is-swapping-in');
            if (leadEl) leadEl.classList.remove('is-swapping-in');
            // Defensive cleanup in case the user navigates away mid-swap.
            swapInTimer = setTimeout(clearSwapClasses, 600);
          });
        });
        swapTimer = null;
      }, 220);
    }

    function showSlide(idx, opts) {
      opts = opts || {};
      const next = ((idx % slideCount) + slideCount) % slideCount;
      slides.forEach((s, i) => { s.style.opacity = (i === next) ? '1' : '0'; });
      // Lazy-start any deferred videos so they don't all play at once
      const nextEl = slides[next];
      if (nextEl) {
        const v = nextEl.querySelector('video[data-defer]');
        if (v) { v.removeAttribute('data-defer'); try { v.play(); } catch(e){} }
      }
      // Swap heading/lead text + highlight chip
      swapHeroContent(nextEl, next);
      const wrapping = opts.wrap === true;
      current = next;
      if (wrapping) {
        dotEls.forEach((_, i) => setDotProgress(i, 0));
      } else {
        paintDots();
      }
      startProgress();
      restartTimer();
    }

    function nextSlide() {
      const target = (current + 1) % dotCount;
      const wrap = target === 0;
      showSlide(target % slideCount, { wrap: wrap });
    }

    function restartTimer() {
      if (timer) clearTimeout(timer);
      timer = setTimeout(nextSlide, SLIDE_MS);
    }

    // Wire dot clicks — paint dots, then route through showSlide() so the
    // heading/lead/highlight chip swap fires too (was a real bug: tap on a
    // dot changed the image but text stayed frozen on previous slide).
    dotEls.forEach((dot, i) => {
      dot.btn.addEventListener('click', () => {
        dotEls.forEach((_, j) => {
          if (j < i) setDotProgress(j, 1);
          else setDotProgress(j, 0);
        });
        // showSlide handles: opacity, video play, swapHeroContent, dots, timer
        showSlide(i % slideCount);
      });
    });

    // ── Right-side "next slide" arrow ──
    // Replaces the page-number indicators per user request. Styled in
    // the DC MARKET aesthetic (orange + hard ink shadow). Only shown
    // when there are 2+ real slides — single-slide hero gets no arrow.
    if (slideCount >= 2) {
      const arrow = hero.querySelector('.hero__nav-next')
        || (function(){
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'hero__nav-next';
          btn.setAttribute('aria-label', 'Slide următor');
          btn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true"><path d="M5 12h14M13 5l7 7-7 7"/></svg>';
          hero.appendChild(btn);
          return btn;
        })();
      arrow.addEventListener('click', function(e){
        e.preventDefault();
        nextSlide();
      });
    }

    // Start
    if (slideCount >= 1) showSlide(0);
  }
  dcmRegister(heroSlideshow);

  // ── Recover CSS rules dropped by parse error in dcm-sections.css ──
  // The .testimonial__quote::before/::after rules have unmatched quotes
  // (Shopify keeps reverting our fix). The parser stops there and silently
  // drops ~168 rules. Fetch the file, fix the broken rule, inject as a new
  // <style> element so the full CSS parses correctly.
  (function recoverCss() {
    if (document.getElementById('dcm-recovered-css')) return;
    const sectLink = Array.from(document.querySelectorAll('link[rel=stylesheet]')).find(l => l.href.includes('dcm-sections'));
    if (!sectLink) return;
    fetch(sectLink.href).then(r => r.text()).then(t => {
      const fixed = t
        .replace(/\.testimonial__quote::before\s*\{[^}]*\}/g, '.testimonial__quote::before { content: "\\201C"; font-weight: 700; color: var(--color-orange); }')
        .replace(/\.testimonial__quote::after\s*\{[^}]*\}/g, '.testimonial__quote::after { content: "\\201D"; font-weight: 700; color: var(--color-orange); }');
      const extras = `
/* Hero fullscreen — fits exactly between top bar and viewport bottom.
   --top-bar-h is set dynamically by JS = announcement + hazard heights */
.hero, .hero--small, .hero--medium, .hero--large, .hero--full {
  min-height: calc(100vh - var(--top-bar-h, 46px)) !important;
  margin-top: calc(-1 * var(--nav-h, 89px)) !important;
}
/* Progress lines anchor to bottom of viewport, not bottom of hero.
   Mobile value lives in dcm-overrides-v3.css (15rem) — leave unset here so the
   stylesheet rule wins. */
.hero__dots { bottom: 4rem !important; }
/* JS-driven slideshow indicators — bigger tap targets on mobile.
   Visible bar stays small but the clickable area is 44px tall via padding
   so it meets iOS HIG (44pt minimum). The fill span is positioned
   relative to the visible bar (the inner .hero__dot-track element). */
.hero__dots {
  display: inline-flex !important;
  gap: 0 !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  position: absolute !important;
  z-index: 4 !important;
}
.hero__dot {
  width: 48px !important;
  height: auto !important;
  min-height: 44px !important;
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  padding: 20px 3px !important;
  margin: 0 !important;
  cursor: pointer !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative !important;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}
/* The visible bar — linear-gradient splits at --dot-progress (0..1)
   so the orange fills gradually from left to right. */
.hero__dot::before {
  content: "" !important;
  display: block !important;
  width: 100% !important;
  height: 3px !important;
  background: linear-gradient(
    to right,
    var(--color-orange) 0,
    var(--color-orange) calc(var(--dot-progress, 0) * 100%),
    rgba(244,243,239,0.35) calc(var(--dot-progress, 0) * 100%),
    rgba(244,243,239,0.35) 100%
  ) !important;
  position: relative !important;
  transition: none !important;
}
.hero__dot:hover::before { opacity: 0.9; }
.hero__dot-fill { display: none !important; }
@media (max-width: 989px) {
  .hero__dot { width: 54px !important; padding: 22px 4px !important; min-height: 48px !important; }
  .hero__dots { gap: 0 !important; }
}
`;
      const style = document.createElement('style');
      style.id = 'dcm-recovered-css';
      style.textContent = fixed + extras;
      document.head.appendChild(style);
    }).catch(() => {});
  })();

  // ── Inject button shadow effect overrides via <style> tag ──
  // CSS overrides moved to assets/dcm-overrides.css (loaded in <head>) to kill FOUC.
  // Below: kept as a no-op safety net in case the stylesheet is missing.
  (function injectBtnStyles() {
    if (document.getElementById('dcm-btn-overrides')) return;
    // Detect the real stylesheet — if loaded, skip JS injection
    var hasOverrides = !!Array.from(document.styleSheets).find(function(s){ return (s.href||'').indexOf('dcm-overrides') >= 0; });
    if (hasOverrides) return;
    const style = document.createElement('style');
    style.id = 'dcm-btn-overrides';
    style.textContent = [
      '.btn--primary, .header__cta {',
      '  box-shadow: 8px 8px 0 0 var(--color-ink) !important;',
      '  transition: transform .25s ease, box-shadow .25s ease, background .18s, color .18s !important;',
      '}',
      '.btn--primary:hover, .header__cta:hover {',
      '  transform: translate(-3px, -3px);',
      '  box-shadow: 14px 14px 0 0 var(--color-ink) !important;',
      '}',
      /* Hero / dark-scheme primary CTA: clean refined chip (no hard offset shadow).
         Solid orange, soft elevation on hover only, inverts to ink on hover for affordance. */
      '.hero .btn--primary, .quote-cta.scheme-ink .btn--primary, .quote-cta.scheme-steel .btn--primary {',
      '  box-shadow: none !important;',
      '  border: 0 !important;',
      '  border-radius: 0 !important;',
      '  background: var(--color-orange) !important;',
      '  color: var(--color-ink) !important;',
      '  transition: background 0.22s ease, color 0.22s ease, transform 0.22s ease, box-shadow 0.22s ease !important;',
      '}',
      '.hero .btn--primary:hover, .quote-cta.scheme-ink .btn--primary:hover, .quote-cta.scheme-steel .btn--primary:hover {',
      '  background: var(--color-ink) !important;',
      '  color: var(--color-orange) !important;',
      '  transform: translateY(-2px) !important;',
      '  box-shadow: 0 8px 22px rgba(0,0,0,0.3) !important;',
      '}',
      '.hero .btn--primary:active, .quote-cta.scheme-ink .btn--primary:active {',
      '  transform: translateY(0) !important;',
      '  box-shadow: 0 2px 8px rgba(0,0,0,0.2) !important;',
      '}',
      /* Ghost "Vezi produsele" — pair it cleanly with the primary */
      '.hero .btn--ghost { border-width: 2px !important; transition: background 0.22s ease, color 0.22s ease, border-color 0.22s ease, transform 0.22s ease !important; }',
      '.hero .btn--ghost:hover { background: rgba(255,255,255,0.08) !important; border-color: var(--color-orange) !important; color: var(--color-orange) !important; transform: translateY(-2px) !important; }',
      /* No border under header / announcement — clean transition into hero */
      '.header, .header--ink, .header.header--over-hero, .announcement { border-bottom: 0 !important; }',
      /* Hide the 01/03 carousel counter sitewide */
      '.dcm-mq__counter, [data-marquee-counter] { display: none !important; }',
      /* Remove the left/right fade that was blurring the heading text */
      '.dcm-mq__card--fade .dcm-mq__viewport::before,',
      '.dcm-mq__card--fade .dcm-mq__viewport::after,',
      '.dcm-mq__card::before,',
      '.dcm-mq__card::after { display: none !important; background: none !important; mask-image: none !important; -webkit-mask-image: none !important; }',
      '.dcm-mq__heading { mask-image: none !important; -webkit-mask-image: none !important; }',
      /* Hero progress lines styled in dcm-recovered-css; kill any ::after fallback */
      '.hero__dot::after { display: none !important; content: none !important; animation: none !important; }',
      /* BRANDS: not a carousel — static row of all logos */
      '.dcm-mq--brands .dcm-mq__nav,',
      '.dcm-mq--brands .dcm-mq__progress-wrap,',
      '.dcm-mq--brands .dcm-mq__footer-row,',
      '.dcm-mq--brands [data-marquee-prev],',
      '.dcm-mq--brands [data-marquee-next],',
      '.dcm-mq--brands [data-marquee-progress] { display: none !important; }',
      '.dcm-mq--brands .dcm-mq__viewport::before,',
      '.dcm-mq--brands .dcm-mq__viewport::after { display: none !important; }',
      '.dcm-mq--brands .dcm-mq__track {',
      '  transform: none !important;',
      '  transition: none !important;',
      '  animation: none !important;',
      '  display: flex !important;',
      '  justify-content: center !important;',
      '  width: 100% !important;',
      '}',
      '.dcm-mq--brands .dcm-mq__slide[aria-hidden="true"] { display: none !important; }',
      '.dcm-mq--brands .dcm-mq__slide { flex: 1 1 0 !important; min-width: 0 !important; }',
      /* Make headings/buttons NOT BOLD — keep original Bebas Neue display font but normal weight */
      'h1, h2, h3, h4, h5, h6, .display, .h0,',
      '.btn, .header__cta, .header__nav-link,',
      '.hero__heading, .hero__lead,',
      '.cat-card__title, .cat-split__title,',
      '.trust-cell__title,',
      '.quote-cta__heading,',
      '.dcm-mq__heading, .brand-row__title, .logo-row__title,',
      '.footer h4,',
      '.notfound h1,',
      '.mobile-menu__list a,',
      '.collection__title, .product__title {',
      '  font-weight: 400 !important;',
      '}',
      /* MOBILE HEADER — flex with space-between so logo hugs left edge,
         actions hug right edge. Plus tighten icon sizes, hide search/CTA,
         hamburger lines white, and shrink hero progress lines. */
      '@media (max-width: 989px) {',
      '  .header__cta { display: none !important; }',
      '  .header .header__icon-btn[href*="search"] { display: none !important; }',
      '  .header__nav { display: none !important; }',
      '  .header__inner { display: flex !important; flex-direction: row !important; justify-content: space-between !important; align-items: center !important; padding: 2.4rem 1.2rem 1.2rem !important; gap: 0 !important; grid-template-columns: none !important; }',
      '  .header__logo { display: inline-flex !important; align-items: center !important; flex: 0 0 auto !important; }',
      '  .header__logo img, .header__logo svg { display: block !important; }',
      '  .header__actions { display: inline-flex !important; gap: 1.2rem !important; padding-right: 0 !important; margin-right: 0 !important; align-items: center !important; flex: 0 0 auto !important; }',
      '  .header__icon-btn { width: 4.4rem !important; height: 4.4rem !important; color: #fafaf7 !important; }',
      '  .header__icon-btn svg { color: #fafaf7 !important; stroke: #fafaf7 !important; }',
      '  .header__menu-btn { display: inline-flex !important; width: 3.6rem !important; height: 3.6rem !important; padding: 0 !important; background: transparent !important; border: 0 !important; align-items: center !important; justify-content: center !important; }',
      '  .header__menu-btn span { background: #fafaf7 !important; width: 20px !important; height: 2px !important; }',
      /* hero dot mobile sizing handled in dcm-recovered-css */
      '}',
      /* Mobile-menu drawer close button visibility (was transparent on cream bg) */
      '.mobile-menu .header__icon-btn { color: var(--color-ink) !important; }',
      '.mobile-menu .header__icon-btn svg { color: var(--color-ink) !important; stroke: var(--color-ink) !important; width: 24px; height: 24px; }',
      '.mobile-menu .header__icon-btn:hover { background: var(--color-ink) !important; color: var(--color-paper) !important; }',
      '.mobile-menu .header__icon-btn:hover svg { color: var(--color-paper) !important; stroke: var(--color-paper) !important; }',

      /* ── TAP FEEDBACK (mobile): mirror :hover styles into .dcm-tap-active ──
         JS adds this class for 240ms before navigating, so the user sees the
         animation play before the page transitions. */
      '.btn--primary.dcm-tap-active, .header__cta.dcm-tap-active { background: var(--color-ink) !important; color: var(--color-orange) !important; transform: translateY(-2px) !important; box-shadow: 0 8px 22px rgba(0,0,0,0.3) !important; }',
      '.btn--ghost.dcm-tap-active { background: rgba(255,255,255,0.08) !important; border-color: var(--color-orange) !important; color: var(--color-orange) !important; transform: translateY(-2px) !important; }',
      '.btn--secondary.dcm-tap-active { background: var(--color-steel, #475569) !important; }',
      '.cat-card.dcm-tap-active { transform: translate(-3px, -3px) !important; box-shadow: 10px 10px 0 0 var(--color-ink) !important; }',
      '.cat-card.dcm-tap-active .cat-card__cta { transform: translate(-1px, -1px) !important; box-shadow: 6px 6px 0 0 #0e0e10 !important; }',
      '/* removed: brand tap-active scale */',
      '.footer a.dcm-tap-active { color: var(--color-orange) !important; }',
      '.header__nav-link.dcm-tap-active, a.header__nav-link.dcm-tap-active { color: var(--color-orange) !important; }',
      '.mobile-menu__list a.dcm-tap-active { color: var(--color-orange) !important; }',
      /* Generic fallback so any other link tapped also gets a brief subtle press */
      'a.dcm-tap-active:not(.btn):not(.header__cta):not(.cat-card) { opacity: 0.78 !important; transition: opacity 0.18s ease !important; }',

      /* ── DESIGN-INTELLIGENCE PASS (skill: Construction palette + Swiss Modernism 2.0) ── */

      /* Slate body copy instead of pure ink (skill row #53: text #334155, border #E2E8F0).
         Matches "industrial grey + safety orange" recommendation. */
      '.hero__lead { color: rgba(244, 243, 239, 0.86) !important; }',
      /* Hero text shadow — soft dark halo for legibility on busy backgrounds (matches logo gradient feel) */
      '.hero__heading, .hero__lead { text-shadow: 0 4px 24px rgba(14,14,16,0.55), 0 2px 8px rgba(14,14,16,0.45) !important; }',
      '.hero__heading-mark { text-shadow: none !important; }',
      /* Slate body text only on LIGHT (paper) sections — keep dark sections legible */
      '.trust-cell__text, .cat-split__lead, .quote-cta__lead { color: #334155 !important; }',
      '.scheme-ink .trust-cell__text, .scheme-ink .cat-split__lead, .scheme-ink .quote-cta__lead { color: rgba(244,243,239,0.78) !important; }',
      /* Footer is dark — paragraph text was rendering in slate-dark on dark-bg (unreadable). */
      '.footer p, .footer .footer__about p, .footer__col p { color: rgba(244,243,239,0.74) !important; }',
      '.footer a { color: rgba(244,243,239,0.92) !important; }',
      '.footer a:hover { color: var(--color-orange) !important; }',
      /* Remove the thin orange line above the footer (was an <hr class="hazard--thin">) */
      '.footer { border-top: 0 !important; box-shadow: none !important; }',
      '.footer::before { display: none !important; content: none !important; }',
      '.hazard--thin { display: none !important; }',

      /* Soften hairline borders on trust cells only — cat-card keeps its orange frame */
      '.trust-cell { border-color: #E2E8F0 !important; }',

      /* :focus-visible rings (skill UX rule #28: HIGH severity — was missing).
         Uses orange to match brand accent; offset for clarity over any background. */
      'a:focus-visible, button:focus-visible, .btn:focus-visible, .header__cta:focus-visible, .cat-card:focus-visible, .hero__dot:focus-visible, .header__icon-btn:focus-visible { outline: 2px solid var(--color-orange) !important; outline-offset: 3px !important; border-radius: 2px; }',
      /* Don\'t show focus ring on plain mouse clicks */
      'a:focus:not(:focus-visible), button:focus:not(:focus-visible), .btn:focus:not(:focus-visible) { outline: none !important; }',

      /* prefers-reduced-motion (skill UX rule #11 + universal a11y baseline).
         Disables decorative motion for users with vestibular sensitivity. */
      '@media (prefers-reduced-motion: reduce) {',
      '  *, *::before, *::after { animation-duration: 0.01ms !important; animation-iteration-count: 1 !important; transition-duration: 0.01ms !important; }',
      '  .dcm-bm__track { animation: none !important; }',
      '  .hero__slide { transition: none !important; }',
      '  .cat-card:hover { transform: none !important; }',
      '}',

      /* Touch-target safety (skill UX rule #22+#23: HIGH).
         Header icon buttons must be ≥44×44 with ≥8px gap. */
      '.header__actions { gap: max(0.8rem, 8px) !important; }',
      '.header__icon-btn { min-width: 44px !important; min-height: 44px !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; }',

      /* ── HOMEPAGE POLISH (Phase-8 audit) ── */

      /* Body font swap — Roboto for everything that doesn't have an explicit Bebas
         override (so headings, buttons, hero text keep their display font).
         Also disable iOS Safari's auto text inflation. */
      'html, body { font-family: "Roboto", Arial, Helvetica, sans-serif !important; -webkit-text-size-adjust: 100% !important; text-size-adjust: 100% !important; }',
      /* Force Roboto explicitly on the body-copy targets the user circled */
      '.hero__lead, .trust-cell__text, .cat-split__lead, .quote-cta__lead, .footer p, .footer li, .announcement { font-family: "Roboto", Arial, Helvetica, sans-serif !important; }',

      /* Remove ALL eyebrows site-wide — too many of them, signal-to-noise was bad */
      '.eyebrow, span.eyebrow, p.eyebrow, .hero__eyebrow { display: none !important; }',

      /* Hide announcement bar when it has no messages (avoids empty dark strip) */
      '.announcement:has(.announcement__inner:empty) { display: none !important; }',

      /* Header CTA — clean, refined, no brutalist offset shadow on this small button.
         Solid orange chip with subtle hover lift. */
      '.header__cta { font-size: 1.8rem !important; padding: 1.2rem 2.2rem !important; border: 0 !important; border-radius: 0 !important; box-shadow: none !important; letter-spacing: 0.08em !important; background: var(--color-orange) !important; color: var(--color-ink) !important; transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease !important; }',
      '.header__cta:hover { background: var(--color-ink) !important; color: var(--color-orange) !important; transform: none !important; box-shadow: none !important; }',


      /* Hide placeholder clients section entirely until real content exists.
         Match the outer Shopify section wrapper, not just the inner marquee. */
      '[id*="__clients"], .shopify-section:has(.dcm-mq--clients) { display: none !important; }',

      /* Hero typography: dial heading down, tighten line-height, give it a max-width.
         Was wrapping to 4 lines at 1440 — too dominant. */
      '.hero__heading { font-size: clamp(3.6rem, 5.6vw, 7.2rem) !important; line-height: 0.96 !important; letter-spacing: -0.01em !important; max-width: 12ch !important; }',
      '.hero__lead { max-width: 52ch !important; opacity: 0.92 !important; font-size: clamp(1.5rem, 1.4vw, 1.7rem) !important; line-height: 1.55 !important; }',
      '.hero__inner { gap: 1.4rem !important; }',

      /* Hero dots: slightly more visible against bright/dark backgrounds */
      '.hero__dot::before { box-shadow: 0 0 0 1px rgba(0,0,0,0.18) !important; }',

      /* Trust strip — desktop sizing. Mobile gets its own block in the @media query
         below to defeat iOS Safari's flex+SVG ballooning bug. */
      '.trust-cell { background: var(--color-paper) !important; padding: 2.4rem 2rem !important; align-items: flex-start !important; gap: 1.4rem !important; min-width: 0 !important; }',
      '.trust-row { gap: 2px !important; background: rgba(0,0,0,0.08) !important; }',
      '.trust-cell__icon, .trust-cell__icon--svg { box-sizing: border-box !important; width: 40px !important; height: 40px !important; min-width: 40px !important; max-width: 40px !important; min-height: 40px !important; max-height: 40px !important; flex: 0 0 40px !important; font-size: 40px !important; color: var(--color-orange) !important; overflow: visible !important; }',
      '.trust-cell__icon svg, .trust-cell__icon img, .trust-cell__icon--svg svg, .trust-cell__icon--svg img { width: 40px !important; height: 40px !important; max-width: 40px !important; max-height: 40px !important; min-width: 0 !important; flex: 0 0 auto !important; display: block !important; }',
      '.trust-cell__title { font-size: 1.5rem !important; letter-spacing: 0.02em !important; word-break: break-word !important; }',
      '.trust-cell__text { opacity: 0.75 !important; line-height: 1.55 !important; word-break: break-word !important; }',
      '.trust-cell > *:not(.trust-cell__icon):not(.trust-cell__num) { min-width: 0 !important; flex: 1 1 auto !important; }',

      /* Brands: smaller heading, normalize all logos to a unified mono treatment.
         Each logo currently brings its own colored background — converted to grayscale
         with a clean dark card so the row reads as one curated brand wall. */
      '.dcm-mq--brands .dcm-mq__heading { font-size: clamp(2rem, 2.6vw, 3.4rem) !important; letter-spacing: 0.01em !important; max-width: 22ch !important; }',
      /* Brand wall — dark unified card; colored logos.
         Smooth GPU-accelerated hover: visible scale + opacity ramp. */
      '.dcm-mq--brands .dcm-mq__slide { background: transparent !important; padding: 2.4rem 1.6rem !important; display: flex !important; align-items: center !important; justify-content: center !important; min-height: 11rem !important; }',
      '.dcm-mq--brands .dcm-mq__track { gap: 0 !important; }',
      '/* brand img sizing/hover rules now live in sections/brand-logos.liquid */',
      /* Keep the marquee track from interfering with hover state */
      '.dcm-mq--brands .dcm-mq__track { transform: none !important; transition: none !important; animation: none !important; }',
      /* Hide leftover marquee chrome on brands */
      '.dcm-mq--brands .dcm-mq__progress-wrap, .dcm-mq--brands .dcm-mq__nav, .dcm-mq--brands [data-marquee-progress] { display: none !important; }',

      /* Categories: when only 2 cards render (after empty-block skip), make grid 2-col on desktop */
      '.cat-split__grid:has(> a:nth-child(2):last-child) { --cols-d: 2 !important; }',
      '.cat-card { transition: transform 0.5s cubic-bezier(.2,.8,.2,1), box-shadow 0.5s ease !important; }',
      '.cat-card:hover { transform: translateY(-4px) !important; }',
      '.cat-card__title { font-size: clamp(2rem, 2.4vw, 2.8rem) !important; }',
      '.cat-split__title { font-size: clamp(2.8rem, 4vw, 4.8rem) !important; max-width: 18ch !important; line-height: 1 !important; }',

      /* Hazard stripes: thinner, less shouty */
      '#dcm-hazard-mid { height: 6px !important; }',
      'hr.hazard { height: 6px !important; }',

      /* Logo: dramatically bigger per user request, hardcoded height beats inline var */
      'html body .header__logo img, html body .header__logo svg, html body .header__logo a img, html body .header__logo a svg { height: 120px !important; max-height: 120px !important; width: auto !important; object-fit: contain !important; }',
      '@media (max-width: 989px) {',
      '  html body .header__logo img, html body .header__logo svg, html body .header__logo a img, html body .header__logo a svg { height: 96px !important; max-height: 96px !important; }',
      '  .hero__heading { font-size: clamp(3.2rem, 9vw, 4.8rem) !important; max-width: 14ch !important; }',
      '  .hero__lead { font-size: 1.45rem !important; }',
      /* Mobile: push hero content up so buttons + dots clear iOS Safari bottom bar */
      '  .hero__inner { padding-bottom: calc(13rem + env(safe-area-inset-bottom, 0px)) !important; }',
      '  .hero__dots { bottom: calc(10rem + env(safe-area-inset-bottom, 0px)) !important; }',
      '  .trust-cell { padding: 1.8rem 1.6rem !important; gap: 1.2rem !important; }',
      '  .trust-cell__icon, .trust-cell__icon--svg { width: 36px !important; height: 36px !important; min-width: 36px !important; max-width: 36px !important; min-height: 36px !important; max-height: 36px !important; flex: 0 0 36px !important; font-size: 36px !important; padding: 2px !important; box-sizing: content-box !important; overflow: visible !important; }',
      '  .trust-cell__icon svg, .trust-cell__icon img { width: 36px !important; height: 36px !important; max-width: 36px !important; max-height: 36px !important; aspect-ratio: 1 / 1 !important; object-fit: contain !important; }',
      '  .trust-cell__title { font-size: 1.4rem !important; line-height: 1.2 !important; }',
      '  .trust-cell__text { font-size: 1.3rem !important; }',
      '  .dcm-mq--brands .dcm-mq__slide { min-height: 8rem !important; padding: 1rem !important; }',
      '  /* mobile brand img height handled by sections/brand-logos.liquid */',
      '  .cat-split__title { font-size: clamp(2.4rem, 7vw, 3.2rem) !important; }',
      /* announcement font-size now controlled by sections/announcement-bar.liquid */
      '}',

      /* Quote-CTA bullets card has paper bg but inherits paper text on scheme-ink.
         Force ink text for the labels (the num span keeps its orange via inline style). */
      '.quote-cta .quote-cta__bullets { color: var(--color-ink) !important; }',
      '.quote-cta .quote-cta__bullet > span:not(.quote-cta__bullet-num) { color: var(--color-ink) !important; font-weight: 500 !important; }',

      /* ── BRUTALIST INSPIRATION (hero highlight + marquee + card chip) ── */

      /* Hero heading: last word wrapped in orange chip with hard offset shadow.
         BRUTAL aesthetic: subtle -1.4° tilt for the "intentionally pasted" look. */
      '.hero__heading-mark { display: inline-block; background: var(--color-orange) !important; color: var(--color-ink) !important; padding: 0 0.18em 0.04em !important; box-shadow: 6px 6px 0 0 #0e0e10 !important; transform: translateY(-0.02em) rotate(-1.4deg); transform-origin: left center; }',
      '@media (max-width: 989px) { .hero__heading-mark { box-shadow: 4px 4px 0 0 #0e0e10 !important; padding: 0 0.16em 0.02em !important; transform: translateY(-0.02em) rotate(-1.2deg); } }',

      /* Cat-card category tag chip — BRUTAL "Creative" pill, in YOUR orange */
      '.dcm-cat-tag { display: inline-block !important; background: var(--color-orange) !important; color: var(--color-ink) !important; font-family: "Bebas Neue", sans-serif !important; font-size: 1.1rem !important; letter-spacing: 0.14em !important; padding: 0.4rem 0.8rem !important; box-shadow: 3px 3px 0 0 #0e0e10 !important; margin-bottom: 0.8rem !important; align-self: flex-start !important; transform: rotate(-1deg); }',

      /* Sparkle marquee strip — dark band between hero and trust strip */
      '.dcm-bm { background: var(--color-ink); color: var(--color-paper); overflow: hidden; padding: 1.4rem 0; border-top: 1px solid rgba(255,255,255,0.06); border-bottom: 1px solid rgba(255,255,255,0.06); }',
      '.dcm-bm__track { display: inline-flex; align-items: center; white-space: nowrap; animation: dcm-bm-scroll 38s linear infinite; }',
      '.dcm-bm__item { font-family: "Bebas Neue", sans-serif; letter-spacing: 0.08em; font-size: 1.6rem; padding: 0 1.6rem; }',
      '.dcm-bm__sep { color: var(--color-orange); font-size: 1.3rem; padding: 0 0.4rem; }',
      '@keyframes dcm-bm-scroll { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }',
      '@media (max-width: 989px) { .dcm-bm__item { font-size: 1.4rem; padding: 0 1.2rem; } .dcm-bm { padding: 1.1rem 0; } }',

      /* Cat-card CTA — orange arrow chip in bottom right with hard offset shadow */
      '.cat-card { position: relative !important; }',
      '.cat-card__cta { display: inline-flex !important; align-items: center !important; gap: 0.6rem !important; background: var(--color-orange) !important; color: var(--color-ink) !important; padding: 0.9rem 1.4rem !important; font-family: "Bebas Neue", sans-serif !important; font-size: 1.3rem !important; letter-spacing: 0.08em !important; box-shadow: 4px 4px 0 0 #0e0e10 !important; transition: transform 0.2s ease, box-shadow 0.2s ease !important; align-self: flex-start !important; }',
      '.cat-card:hover .cat-card__cta { transform: translate(-1px, -1px) !important; box-shadow: 6px 6px 0 0 #0e0e10 !important; }',

      /* ── MVP POLISH PASS (final audit before launch) ── */

      /* Hide search icon site-wide (CSS catches both <a href> and <button> variants).
         JS-only hide was missing the button case. */
      'a[href*="search"].header__icon-btn, button[aria-controls*="search"], button[data-search-open], .header__icon-btn[aria-label*="aut" i] { display: none !important; }',

      /* Cat-card: door images were 490×490 inside a 656×682 media area = lots of empty
         paper space. Make images fill the available height with object-contain so they scale up. */
      '.cat-card__media { padding: 2rem !important; }',
      '.cat-card__media img { width: 100% !important; height: 100% !important; max-width: none !important; max-height: none !important; object-fit: contain !important; }',
      '.cat-card { aspect-ratio: 4 / 4.2 !important; }',
      '@media (max-width: 989px) { .cat-card { aspect-ratio: 4 / 5 !important; } .cat-card__media { padding: 1.4rem !important; } }',

      /* Quote-CTA heading: was 96px on desktop (too dominant). Scale + clamp. */
      '.quote-cta__heading { font-size: clamp(3.4rem, 5.2vw, 6rem) !important; line-height: 0.96 !important; max-width: 18ch !important; letter-spacing: -0.005em !important; }',
      '.quote-cta__lead { font-size: clamp(1.5rem, 1.4vw, 1.75rem) !important; line-height: 1.55 !important; }',
      '.quote-cta__bullets { padding: 2rem !important; }',
      '@media (max-width: 989px) { .quote-cta__heading { font-size: clamp(2.8rem, 8vw, 4rem) !important; } }',

      /* Cat-split heading + lead: tighten alignment so they read as a pair, not a split */
      '.cat-split__head { gap: 2rem !important; align-items: end !important; }',
      '.cat-split__title { letter-spacing: -0.005em !important; }',
      /* Mobile: stack heading + lead vertically (was rendering side-by-side, title pushed right) */
      '@media (max-width: 989px) {',
      '  .cat-split__head { grid-template-columns: 1fr !important; align-items: start !important; gap: 1.2rem !important; display: block !important; }',
      '  .cat-split__head > * { width: 100% !important; max-width: 100% !important; }',
      '  .cat-split__lead { margin-top: 1rem !important; }',
      '}',

      /* Footer: 2026-06-02 — Contact column + bottom row are NO LONGER hidden.
         The previous hide-rules removed the ANPC SAL / SOL badges and the
         copyright + CIF + registration line, which is legally required
         info for a RO e-commerce site. Bringing them back via stock CSS. */
      '.footer { padding-top: 6rem !important; padding-bottom: 4rem !important; }'
    ].join('\n');
    document.head.appendChild(style);
  })();

  // ── Force header icon color white over hero ──
  (function fixHeaderIcons() {
    const header = document.querySelector('.header');
    if (!header) return;
    const icons = header.querySelectorAll('.header__icon-btn');
    icons.forEach(i => { i.style.color = '#fafaf7'; });
    const navLinks = header.querySelectorAll('.header__nav-link');
    navLinks.forEach(l => {
      if (l.matches('[aria-current="page"]')) {
        l.style.color = 'var(--color-orange)';
      } else {
        l.style.color = '#fafaf7';
      }
    });
  })();

  // ── Header: set --header-h / --nav-h CSS vars + scroll-to-ink ──
  const header = document.querySelector('.header');
  if (header) {
    function setHeaderVars() {
      const rect = header.getBoundingClientRect();
      // --header-h = total distance from top of page to header bottom (includes announcement bar etc.)
      const offsetTop = header.offsetTop;
      const h = header.offsetHeight;
      document.documentElement.style.setProperty('--header-h', (offsetTop + h) + 'px');
      document.documentElement.style.setProperty('--nav-h', h + 'px');
      // --top-bar-h = total height of everything above the header (announcement + hazard)
      // Used by .hero min-height: calc(100vh - var(--top-bar-h)) so hero ends exactly at viewport bottom
      const ann = document.querySelector('.announcement');
      const hz = document.getElementById('dcm-hazard-mid');
      const annH = ann ? ann.offsetHeight : 0;
      const hzH = hz ? hz.offsetHeight : 0;
      document.documentElement.style.setProperty('--top-bar-h', (annH + hzH) + 'px');
    }
    setHeaderVars();
    // iOS Safari fires `resize` continuously while the URL bar collapses
    // / expands (height changes, width does NOT). If we re-run setHeaderVars
    // on those events, --nav-h gets rewritten and any element using it for
    // margin-top / padding-top (like .dcm-cl-hero) visibly resizes during
    // the URL bar animation — the user sees the hero "getting smaller" at
    // the top of the page. Gate on width change so we still respond to real
    // window resizes + orientation flips, but ignore URL-bar height jitter.
    var lastInnerWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastInnerWidth) return;
      lastInnerWidth = window.innerWidth;
      setHeaderVars();
    });
    window.addEventListener('orientationchange', function () {
      setTimeout(function () {
        lastInnerWidth = window.innerWidth;
        setHeaderVars();
      }, 300);
    });

    // ── Pill morph trigger ──────────────────────────────────────
    // Add `.header--scrolled` once the user scrolls past a small
    // threshold. The floating-pill treatment keys off THIS class (plus
    // :not(.header--over-hero)) so the pill only appears AFTER the user
    // actually scrolls. At the very top the header keeps its resting
    // look: transparent over a hero (state 1) on hero pages, or the
    // solid full-width bar (state 2) on non-hero pages. Runs on every
    // page — independent of whether a hero exists.
    var SCROLL_PILL_THRESHOLD = 48; // px
    var LANG_FADE_START = 48;       // start fading lang switcher
    var LANG_FADE_END   = 250;      // fully hidden by this scroll
    var langForm = header.querySelector('.dcm-lang');
    var langWidth = langForm ? langForm.offsetWidth : 0;
    var lastScrolled = null;
    function updateScrolledState() {
      var sy = window.scrollY || window.pageYOffset;
      var s = sy > SCROLL_PILL_THRESHOLD;
      if (s !== lastScrolled) {
        header.classList.toggle('header--scrolled', s);
        lastScrolled = s;
      }
      if (langForm) {
        if (sy <= LANG_FADE_START) {
          langForm.style.opacity = '';
          langForm.style.marginRight = '';
          langForm.style.pointerEvents = '';
        } else {
          var t = Math.min((sy - LANG_FADE_START) / (LANG_FADE_END - LANG_FADE_START), 1);
          langForm.style.opacity = (1 - t).toFixed(3);
          langForm.style.marginRight = (-t * langWidth) + 'px';
          langForm.style.pointerEvents = t >= 1 ? 'none' : '';
        }
      }
    }
    var scrolledRaf = false;
    function onScrolledScroll() {
      if (!scrolledRaf) {
        scrolledRaf = true;
        requestAnimationFrame(function () { updateScrolledState(); scrolledRaf = false; });
      }
    }
    window.addEventListener('scroll', onScrolledScroll, { passive: true });
    updateScrolledState();

    // Transparent → ink: watch the top-of-page hero leaving viewport.
    // Covers homepage (.hero), category landing pages (.dcm-cl-hero),
    // and the standalone hero section.
    //
    // Why scroll-Y based instead of IntersectionObserver:
    //   The 220ms background-color + backdrop-filter transition on .header
    //   (see dcm-overrides-v3.css line ~1034) means any rapid toggle of
    //   .header--over-hero produces a visible mid-flight color flash.
    //   IntersectionObserver with `threshold: 0.05` was firing multiple
    //   times near the boundary during iOS Safari URL bar collapse/expand
    //   at top-of-page — the hero's measured intersection ratio jittered
    //   across 0.05 → header strobed between transparent and solid.
    //
    //   A scroll-Y comparison against `hero.offsetTop + hero.offsetHeight`
    //   uses document coordinates (stable — they don't shift with URL bar)
    //   and adds a hysteresis band so the state doesn't flip back-and-forth
    //   when scrollY hovers around the boundary.
    const hero = document.querySelector('.hero, .dcm-cl-hero');
    if (hero) {
      // Start transparent (sync — avoids one-frame flash of solid
      // header on category pages where header.liquid didn't stamp
      // header--over-hero at render time).
      header.classList.add('header--over-hero');
      var heroBottomDoc = 0;          // hero's bottom edge in document coords
      var lastOverHero = true;        // current state — we just added the class
      var HYSTERESIS = 40;            // px — gap between transparent→solid and solid→transparent boundaries
      // 0 = trigger fires when the hero's bottom edge crosses the
      // viewport top (hero fully off-screen). Previously this was 180
      // (subtracting the top-chrome height) so the swap happened while
      // the hero was still under the header — but that made the fade
      // complete during the ~180px before the user perceived "hero
      // gone," so on slow scroll the header would already be solid by
      // the time the user looked at it. With 0 the animation runs
      // through the moment the user actually notices the transition.
      var TOP_CHROME_OFFSET = 0;

      function measureHero() {
        heroBottomDoc = hero.offsetTop + hero.offsetHeight;
      }

      function updateHeaderState() {
        var y = window.scrollY || window.pageYOffset;
        // Header should be solid once the hero's bottom edge crosses
        // BELOW the sticky top chrome (not when it leaves the viewport
        // entirely). Subtract TOP_CHROME_OFFSET so the swap happens
        // ~180px earlier than the raw heroBottom.
        var triggerY = heroBottomDoc - TOP_CHROME_OFFSET;
        var shouldBeOverHero;
        if (lastOverHero) {
          shouldBeOverHero = y < triggerY;
        } else {
          shouldBeOverHero = y < (triggerY - HYSTERESIS);
        }
        if (shouldBeOverHero !== lastOverHero) {
          if (shouldBeOverHero) {
            header.classList.add('header--over-hero');
          } else {
            header.classList.remove('header--over-hero');
          }
          lastOverHero = shouldBeOverHero;
        }
      }

      var headerRaf = false;
      function onHeaderScroll() {
        if (!headerRaf) {
          headerRaf = true;
          requestAnimationFrame(function () {
            updateHeaderState();
            headerRaf = false;
          });
        }
      }

      // Measure after first paint settles
      requestAnimationFrame(function () {
        measureHero();
        updateHeaderState();
      });
      window.addEventListener('scroll', onHeaderScroll, { passive: true });
      // No `resize` listener — iOS Safari fires `resize` during URL bar
      // collapse/expand, which would re-trigger measureHero mid-animation
      // and cause the same flash we're trying to kill. The hero's
      // offsetTop/offsetHeight are document-coordinate stable; they only
      // change on real orientation flips and after image-load reflow.
      window.addEventListener('orientationchange', function () {
        setTimeout(function () { measureHero(); updateHeaderState(); }, 300);
      });
      window.addEventListener('load', function () {
        measureHero();
        updateHeaderState();
      }, { once: true });
    } else {
      // Non-hero pages: always solid (no over-hero class)
      header.classList.remove('header--over-hero');
    }
  }

  // Mobile menu toggle + backdrop
  const menuBtn = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (menuBtn && menu) {
    var menuBackdrop = document.createElement('div');
    menuBackdrop.className = 'dcm-menu-backdrop';
    document.body.appendChild(menuBackdrop);

    var openMenu = function () {
      menu.classList.add('is-open');
      menuBackdrop.classList.add('is-open');
      menuBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };
    var closeMenu = function () {
      menu.classList.remove('is-open');
      menuBackdrop.classList.remove('is-open');
      menuBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };

    menuBtn.addEventListener('click', function () {
      menu.classList.contains('is-open') ? closeMenu() : openMenu();
    });
    menu.querySelectorAll('[data-menu-close]').forEach(function (el) {
      el.addEventListener('click', closeMenu);
    });
    menuBackdrop.addEventListener('click', closeMenu);
  }

  // Cart drawer
  const drawer = document.querySelector('[data-cart-drawer]');
  const backdrop = document.querySelector('[data-cart-backdrop]');
  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    backdrop && backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    backdrop && backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  document.querySelectorAll('[data-cart-open]').forEach(btn =>
    btn.addEventListener('click', e => { e.preventDefault(); openDrawer(); refreshDrawer(); })
  );
  document.querySelectorAll('[data-cart-close]').forEach(btn => btn.addEventListener('click', closeDrawer));
  backdrop && backdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  // Refresh drawer body via section rendering
  async function refreshDrawer() {
    if (!drawer) return;
    try {
      const res = await fetch('/?section_id=cart-drawer', { headers: { Accept: 'text/html' } });
      const html = await res.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const newBody = tmp.querySelector('[data-cart-drawer-body]');
      const cur = drawer.querySelector('[data-cart-drawer-body]');
      if (newBody && cur) cur.innerHTML = newBody.innerHTML;
      attachQtyHandlers();
    } catch (err) { /* fail silently */ }
  }

  // Variant pills (radio-style)
  const variantWraps = document.querySelectorAll('[data-variants]');
  variantWraps.forEach(wrap => {
    const pills = wrap.querySelectorAll('[data-variant-pill]');
    const select = wrap.querySelector('[data-variant-select]');
    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        pills.forEach(p => p.setAttribute('aria-checked', 'false'));
        pill.setAttribute('aria-checked', 'true');
        if (select) {
          select.value = pill.dataset.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  });

  // Qty steppers
  function attachQtyHandlers() {
    document.querySelectorAll('[data-qty]').forEach(group => {
      if (group.dataset.bound === '1') return;
      group.dataset.bound = '1';
      const input = group.querySelector('input');
      const minus = group.querySelector('[data-qty-minus]');
      const plus = group.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', () => {
        const v = Math.max(parseInt(input.value || '1', 10) - 1, parseInt(input.min || '1', 10));
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (plus) plus.addEventListener('click', () => {
        input.value = parseInt(input.value || '1', 10) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }
  attachQtyHandlers();

  // Async add-to-cart on product page
  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', async e => {
      e.preventDefault();
      const submit = productForm.querySelector('[type="submit"]');
      if (submit) { submit.disabled = true; submit.dataset.label = submit.textContent; submit.textContent = 'Se adaugă...'; }
      try {
        const fd = new FormData(productForm);
        fd.append('sections', 'cart-drawer,cart-icon');
        const res = await fetch('/cart/add.js', { method: 'POST', body: fd });
        const data = await res.json();
        if (data.status) throw new Error(data.description || data.message);
        await refreshCartIcon();
        await refreshDrawer();
        openDrawer();
      } catch (err) {
        alert(err.message || 'Eroare la adăugare în coș');
      } finally {
        if (submit) { submit.disabled = false; submit.textContent = submit.dataset.label || 'Adaugă în coș'; }
      }
    });
  }

  async function refreshCartIcon() {
    try {
      const res = await fetch('/?section_id=cart-icon', { headers: { Accept: 'text/html' } });
      const html = await res.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const newIcon = tmp.querySelector('[data-cart-icon]');
      const cur = document.querySelector('[data-cart-icon]');
      if (newIcon && cur) cur.innerHTML = newIcon.innerHTML;
    } catch (err) { /* fail silently */ }
  }

  // Cart line qty change (drawer + cart page)
  document.body.addEventListener('change', async e => {
    const t = e.target;
    if (!(t.matches('[data-line-qty]'))) return;
    const key = t.dataset.lineKey;
    const qty = parseInt(t.value, 10);
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      if (!res.ok) throw new Error('cart change failed');
      await refreshDrawer();
      await refreshCartIcon();
      // If on cart page, reload to refresh totals
      if (document.querySelector('[data-cart-page]')) location.reload();
    } catch (err) { /* fail silently */ }
  });

  // Remove line item
  document.body.addEventListener('click', async e => {
    const a = e.target.closest('[data-line-remove]');
    if (!a) return;
    e.preventDefault();
    const key = a.dataset.lineKey;
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      await refreshDrawer();
      await refreshCartIcon();
      if (document.querySelector('[data-cart-page]')) location.reload();
    } catch (err) { /* noop */ }
  });

  // Product image gallery (thumb selection)
  document.querySelectorAll('[data-gallery]').forEach(gal => {
    const main = gal.querySelector('[data-gallery-main] img');
    gal.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        gal.querySelectorAll('[data-gallery-thumb]').forEach(t => t.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
        if (main) {
          main.src = thumb.dataset.full || thumb.querySelector('img').src;
          main.alt = thumb.querySelector('img').alt;
        }
      });
    });
  });

  // Subcategory card grid: vertical mouse wheel scrolls the cards
  // horizontally. We keep a target scrollLeft and ease toward it on
  // each animation frame — this absorbs multiple rapid wheel events
  // (each one just bumps the target) and produces a smooth glide.
  // Falls through to page scroll at the edges so the user isn't
  // trapped on the section.
  document.querySelectorAll('.dcm-cl-subs__grid').forEach(grid => {
    let target = grid.scrollLeft;
    let rafId = null;
    let lastConsumedAt = 0;       // timestamp of last wheel event we ate
    const EASE = 0.22;            // higher = snappier, lower = floatier
    const WHEEL_MULT = 1.8;       // amplify each wheel tick
    const MOMENTUM_LOCK_MS = 220; // Mac trackpad momentum window

    function tick() {
      const cur = grid.scrollLeft;
      const diff = target - cur;
      if (Math.abs(diff) < 0.5) {
        grid.scrollLeft = target;
        rafId = null;
        return;
      }
      grid.scrollLeft = cur + diff * EASE;
      rafId = requestAnimationFrame(tick);
    }

    // If the user touches/swipes/drags the scroller, sync our target
    // to whatever they scrolled to so the RAF loop doesn't fight them.
    grid.addEventListener('scroll', () => {
      if (rafId === null) target = grid.scrollLeft;
    }, { passive: true });

    grid.addEventListener('wheel', (e) => {
      if (e.deltaY === 0) return;
      const max = grid.scrollWidth - grid.clientWidth;
      if (max <= 0) return;

      const now = Date.now();
      const inMomentum = (now - lastConsumedAt) < MOMENTUM_LOCK_MS;
      const goingRight = e.deltaY > 0;
      const atEdge = (goingRight && target >= max - 1) ||
                     (!goingRight && target <= 0);

      // At an edge AND we haven't been actively scrolling the carousel:
      // fall through so the page can scroll. But if we're mid-gesture
      // (momentum still rolling from a recent consume), eat the event
      // anyway — Mac trackpads emit dozens of momentum ticks after the
      // fingers lift, and letting them bleed into page scroll feels
      // like the page is "also scrolling".
      if (atEdge && !inMomentum) return;

      e.preventDefault();
      lastConsumedAt = now;
      if (!atEdge) {
        target = Math.max(0, Math.min(max, target + e.deltaY * WHEEL_MULT));
        if (rafId === null) rafId = requestAnimationFrame(tick);
      }
    }, { passive: false });

    // Forward-only nav arrow at the right edge of the carousel.
    // Click advances by one card; loops back to start at the end.
    // Anchor inside .dcm-cl-inner so the button stays within the
    // bounded content area instead of getting clipped by the viewport.
    const subsBox = grid.closest('.dcm-cl-inner') || grid.closest('.dcm-cl-subs');
    if (subsBox && !subsBox.querySelector('.dcm-cl-subs__step')) {
      const stepBtn = document.createElement('button');
      stepBtn.type = 'button';
      stepBtn.className = 'dcm-cl-subs__step';
      stepBtn.setAttribute('aria-label', 'Cardul următor');
      stepBtn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
      stepBtn.addEventListener('click', () => {
        const max = grid.scrollWidth - grid.clientWidth;
        if (max <= 0) return;
        const firstCard = grid.querySelector('.dcm-cl-sub-card');
        const step = firstCard
          ? firstCard.getBoundingClientRect().width + 16
          : 336;
        // If already at (or past) the end, loop back to start.
        if (target >= max - 2) {
          target = 0;
        } else {
          target = Math.min(max, target + step);
        }
        lastConsumedAt = Date.now();
        if (rafId === null) rafId = requestAnimationFrame(tick);
      });
      subsBox.appendChild(stepBtn);

      // Align the button vertically with the cards row (not with the
      // full .dcm-cl-inner height which also includes the head + dots).
      function positionStepBtn() {
        const gridRect = grid.getBoundingClientRect();
        const boxRect = subsBox.getBoundingClientRect();
        const mid = (gridRect.top + gridRect.height / 2) - boxRect.top;
        stepBtn.style.top = mid + 'px';
      }
      positionStepBtn();
      window.addEventListener('resize', positionStepBtn, { passive: true });
      window.addEventListener('load', positionStepBtn);
    }
  });
})();

/* ──────────────────────────────────────────────────────────────────
   Logo strip: click-and-drag to scroll on desktop. Mobile already
   slides natively via overflow-x:auto + touch. Wires up after the
   logos markup is injected, retries until it appears.
   ────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  function wire(strip) {
    if (!strip || strip.dataset.dcmDragWired === '1') return;
    // The logo strip now uses a pure-CSS transform marquee (see
    // sections/dcm-client-logos.liquid). When that's active the strip is
    // overflow:hidden, so JS scrollLeft can't move it — wiring the drag +
    // rAF auto-scroll would just burn frames and (on mobile) pause the
    // marquee on every page-scroll touch. Bail and leave the motion to CSS.
    try {
      if (getComputedStyle(strip).overflowX === 'hidden') {
        strip.dataset.dcmDragWired = '1';
        return;
      }
    } catch (e) {}
    strip.dataset.dcmDragWired = '1';
    var down = false, startX = 0, startScroll = 0, moved = false;
    var pendingX = 0, rafQueued = false;
    function tick() {
      rafQueued = false;
      strip.scrollLeft = pendingX;
    }
    // ── Auto-scroll loop ──
    // Speed in px/frame at 60Hz (≈ 36px/sec). Wraps cleanly at the
    // midpoint because the section's logo markup is doubled (the old
    // CSS marquee relied on the same duplication). When scrollLeft
    // reaches the halfway mark, jump back to 0 — the doubled logos
    // make the cut invisible.
    var AUTO_SPEED = 0.6;
    var IDLE_RESUME_MS = 600;
    var autoRaf = 0;
    var paused = false;
    var resumeTimer = 0;
    function autoTick() {
      autoRaf = 0;
      if (paused || down) return;
      var half = strip.scrollWidth / 2;
      var next = strip.scrollLeft + AUTO_SPEED;
      if (half > 0 && next >= half) next -= half;
      strip.scrollLeft = next;
      autoRaf = requestAnimationFrame(autoTick);
    }
    function startAuto() {
      if (autoRaf) return;
      autoRaf = requestAnimationFrame(autoTick);
    }
    function pauseAuto() {
      paused = true;
      if (autoRaf) { cancelAnimationFrame(autoRaf); autoRaf = 0; }
      if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = 0; }
    }
    function scheduleResume() {
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        paused = false;
        startAuto();
      }, IDLE_RESUME_MS);
    }
    // Pause on hover, touch enter, focus inside; resume after idle.
    strip.addEventListener('mouseenter', pauseAuto);
    strip.addEventListener('mouseleave', scheduleResume);
    strip.addEventListener('touchstart', pauseAuto, { passive: true });
    strip.addEventListener('touchend', scheduleResume, { passive: true });
    strip.addEventListener('focusin', pauseAuto);
    strip.addEventListener('focusout', scheduleResume);
    // Pause when tab hidden so we don't burn battery in background.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pauseAuto();
      else if (!down) scheduleResume();
    });
    startAuto();

    // Belt-and-braces: cancel any native HTML5 drag from images/links
    // inside the strip so the browser doesn't take over with a drag-ghost.
    strip.addEventListener('dragstart', function (e) { e.preventDefault(); });
    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') {
        pauseAuto(); // touch scroll also pauses
        return;
      }
      down = true; moved = false;
      startX = e.clientX;
      startScroll = strip.scrollLeft;
      strip.classList.add('dcm-x-logos__strip--dragging');
      strip.setPointerCapture && strip.setPointerCapture(e.pointerId);
      pauseAuto();
      e.preventDefault();
    });
    strip.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      pendingX = startScroll - dx;
      if (!rafQueued) { rafQueued = true; requestAnimationFrame(tick); }
    }, { passive: true });
    function up() {
      if (!down) { scheduleResume(); return; }
      down = false;
      strip.classList.remove('dcm-x-logos__strip--dragging');
      scheduleResume();
    }
    strip.addEventListener('pointerup', up);
    strip.addEventListener('pointercancel', up);
    strip.addEventListener('pointerleave', up);
    // Suppress click on the logo if a drag occurred (so dragging
    // doesn't accidentally navigate via any wrapping link).
    strip.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }
  function attach() {
    document.querySelectorAll('.dcm-x-logos__strip').forEach(wire);
  }
  if (document.readyState !== 'loading') attach();
  else document.addEventListener('DOMContentLoaded', attach);
  // Retry — strip can be injected late by the logos section JS
  var tries = 0;
  var iv = setInterval(function () {
    attach();
    if (++tries > 20) clearInterval(iv);
  }, 250);
})();
